<template>
  <div class="container-fluid h-100">
    <div class="content-profile-user" id="contentProfileUser" alt="Imagen de fondo de perfil">
      <div class="row justify-content-center align-items-center h-100">

        <!-- Sección del perfil administrador -->
        <div v-if="dataUser.role_id == 1" class="col-12 col-md-8 col-lg-8 col-xl-8">
          <div
            class="row justify-content-center justify-content-sm-center justify-content-md-center justify-content-lg-center justify-content-xl-center "
          >
            <div class="col-12 col-md-12 col-lg-12 col-xl-12">
              <h1 class="title-profile-admin">PERFIL DE ADMINISTRACIÓN</h1>
              <template v-if="loading.profile">
                <div class="pr-5" style="text-align: center">
                  <div
                    class="spinner-border text-light"
                    style="width: 5rem; height: 5rem;"
                    role="status"
                  >
                    <span class="sr-only">Loading...</span>
                  </div>
                </div>
              </template>
            </div>
          </div>

          <template v-if="!loading.profile">
            <div class="row pt-3 justify-content-center">
              <div class="col-2 col-md-2 col-lg-2 col-xl-2 padding-sm2">
                <img
                  class="icon-img-svg-name"
                  src="../../assets/img/Recurso 7.png"
                  alt="Compra productos Havoline 4T*"
                />
              </div>
              <div
                class="col-9 col-md-8 col-lg-6 col-xl-6"
                style="text-align: left"
              >
                <label class="label-title "><strong>Nombre</strong></label
                ><br />
                <label> {{ dataUser.name }} {{ dataUser.last_name }}</label>
              </div>
            </div>

            <div class="row pt-xl-3 pt-lg-3 pt-md-3 justify-content-center">
              <div class="col-2 col-md-2 col-lg-2 col-xl-2">
                <img
                  class="icon-img-svg"
                  src="../../assets/img/Recurso 9.png"
                  alt="Compra productos Havoline 4T*"
                />
              </div>
              <div
                class="col-9 col-md-8 col-lg-5 col-xl-5"
                style="text-align: left"
              >
                <label class="label-title text-profile "><strong>Documento</strong></label
                ><br />
                <label class=" text-profile">
                  {{ documentUser }} {{ dataUser.document_number }}</label
                >
              </div>
            </div>

            <div class="row justify-content-center">
              <div class="col-2 col-md-2 col-lg-2 col-xl-2 p-phone">
                <img
                  class="icon-img-svg-phone"
                  src="../../assets/img/Recurso 10.png"
                  alt="Compra productos Havoline 4T*"
                />
              </div>
              <div
                class="col-9 col-md-8 col-lg-5 col-xl-5"
                style="text-align: left"
              >
                <label class="label-title text-profile "><strong>Celular</strong> </label
                ><br />
                <label class=" text-profile">{{ dataUser.phone }}</label>
              </div>
            </div>

            <div class="row justify-content-center">
              <div class="col-2 col-md-2 col-lg-2 col-xl-2">
                <img alt="Placa" class="icon-img-svg" src="../../assets/icon/Placa.png" />
              </div>
              <div
                class="col-9 col-md-8 col-lg-5 col-xl-5"
                style="text-align: left"
              >
                <label class="label-title text-profile "><strong>Placa</strong> </label
                ><br />
                <label class=" text-profile"> {{ dataUser.plate }}</label>
              </div>
            </div>

            <div class="row justify-content-center">
              <div class="col-2 col-md-2 col-lg-2 col-xl-2">
                <img
                  class="icon-img-svg"
                  src="../../assets/img/Recurso 12.png"
                  alt="Compra productos Havoline 4T*"
                />
              </div>
              <div
                class="col-9 col-md-8 col-lg-5 col-xl-5"
                style="text-align: left"
              >
                <label class="label-title text-profile "><strong>Correo</strong> </label
                ><br />
                <label class=" text-profile"> {{ dataUser.email }}</label>
              </div>
            </div>

            <div class="row mt-3 justify-content-center">
              <div class="col-12 col-md-12 col-lg-5 col-xl-4">
                <button
                  class="btn btn-danger btn-sm btn-block"
                  data-toggle="modal"
                  data-target="#exampleModalUpdate"
                  aria-hidden="true"
                >
                  Actualiza tus datos
                </button>
              </div>
              <div
                class="mtPass col-12 col-md-12 col-lg-5 col-xl-4"
                style="text-align: left"
              >
                <button
                  class="btn btn-danger btn-sm btn-block"
                  data-toggle="modal"
                  data-target="#exampleModalPassword"
                  aria-hidden="true"
                >
                  Cambiar contraseña
                </button>
              </div>
            </div>
          </template>
        </div>
        
        <!-- Sección del perfil usuario -->
        <div v-else class="col-12 col-md-7 col-lg-6 col-xl-6">
          <div
            class="row justify-content-center justify-content-sm-center justify-content-md-center justify-content-lg-end justify-content-xl-end "
          >
            <div class="col-12 col-md-12 col-lg-8 col-xl-8">
              <h1 class="title-profile-1">PERFIL</h1>
              <template v-if="loading.profile">
                <div class="pr-5" style="text-align: center">
                  <div
                    class="spinner-border text-light"
                    style="width: 5rem; height: 5rem;"
                    role="status"
                  >
                    <span class="sr-only">Loading...</span>
                  </div>
                </div>
              </template>
            </div>
          </div>

          <template v-if="!loading.profile">
            <div class="row pt-3 justify-content-end">
              <div class="col-2 col-md-2 col-lg-2 col-xl-2 padding-sm2">
                <img
                  class="icon-img-svg-name"
                  src="../../assets/img/Recurso 7.png"
                  alt="Compra productos Havoline 4T*"
                />
              </div>
              <div
                class="col-9 col-md-8 col-lg-6 col-xl-6"
                style="text-align: left"
              >
                <label class="label-title "><strong>Nombre</strong></label
                ><br />
                <label> {{ dataUser.name }} {{ dataUser.last_name }}</label>
              </div>
            </div>

            <div class="row pt-xl-3 pt-lg-3 pt-md-3 justify-content-end">
              <div class="col-2 col-md-2 col-lg-2 col-xl-2">
                <img
                  class="icon-img-svg"
                  src="../../assets/img/Recurso 9.png"
                  alt="Compra productos Havoline 4T*"
                />
              </div>
              <div
                class="col-9 col-md-8 col-lg-5 col-xl-5"
                style="text-align: left"
              >
                <label class="label-title text-profile "><strong>Documento</strong></label
                ><br />
                <label class=" text-profile">
                  {{ documentUser }} {{ dataUser.document_number }}</label
                >
              </div>
            </div>

            <div class="row justify-content-end">
              <div class="col-2 col-md-2 col-lg-2 col-xl-2 p-phone">
                <img
                  class="icon-img-svg-phone"
                  src="../../assets/img/Recurso 10.png"
                  alt="Compra productos Havoline 4T*"
                />
              </div>
              <div
                class="col-9 col-md-8 col-lg-5 col-xl-5"
                style="text-align: left"
              >
                <label class="label-title text-profile "><strong>Celular</strong> </label
                ><br />
                <label class=" text-profile">{{ dataUser.phone }}</label>
              </div>
            </div>

            <div class="row justify-content-end">
              <div class="col-2 col-md-2 col-lg-2 col-xl-2">
                <img alt="Placa" class="icon-img-svg" src="../../assets/icon/Placa.png" />
              </div>
              <div
                class="col-9 col-md-8 col-lg-5 col-xl-5"
                style="text-align: left"
              >
                <label class="label-title text-profile "><strong>Placa</strong> </label
                ><br />
                <label class=" text-profile"> {{ dataUser.plate }}</label>
              </div>
            </div>

            <div class="row justify-content-end">
              <div class="col-2 col-md-2 col-lg-2 col-xl-2">
                <img
                  class="icon-img-svg"
                  src="../../assets/img/Recurso 12.png"
                  alt="Compra productos Havoline 4T*"
                />
              </div>
              <div
                class="col-9 col-md-8 col-lg-5 col-xl-5"
                style="text-align: left"
              >
                <label class="label-title text-profile "><strong>Correo</strong> </label
                ><br />
                <label class=" text-profile"> {{ dataUser.email }}</label>
              </div>
            </div>

            <div class="row mt-3 justify-content-end">
              <div class="col-12 col-md-12 col-lg-5 col-xl-4">
                <button
                  class="btn btn-danger btn-sm btn-block"
                  data-toggle="modal"
                  data-target="#exampleModalUpdate"
                  aria-hidden="true"
                >
                  Actualiza tus datos
                </button>
              </div>
              <div
                class="mtPass col-12 col-md-12 col-lg-5 col-xl-4"
                style="text-align: left"
              >
                <button
                  class="btn btn-danger btn-sm btn-block"
                  data-toggle="modal"
                  data-target="#exampleModalPassword"
                  aria-hidden="true"
                >
                  Cambiar contraseña
                </button>
              </div>
            </div>
          </template>
        </div>

        <!-- Sección de puntos -->
        <div v-if="dataUser.role_id != 1" class="col-12 col-md-7 col-lg-6 col-xl-6">
          <div
            class="row padding-sm-code justify-content-center justify-content-sm-center justify-content-md-center justify-content-lg-center justify-content-xl-center"
          >
            <div
              class="col-12 col-md-12 col-lg-6 col-xl-6 mt-5"
              style="padding-top: 10px; padding-bottom: 4px"
            >
              <div class="title-profile">
                <label class="text-color-1"><strong>Tus códigos / puntos</strong></label>
              </div>
              <div class="points">
                <h1 class="text-points">{{ points }}</h1>
              </div>
              <div class="expired_points">
                <h2 class="title_expired_points">Puntos a vencer este mes</h2>
                <h3 class="cant_expired_points">{{ expired_points }}</h3>
              </div>
              <!-- <form autocomplete="off" id="code">
                <div class="input-group mb-2">
                  <input
                    id="i-p-code"
                    placeholder="Ingresa tus códigos nuevos aquí"
                    v-model="code1"
                    type="text"
                    autocomplete="i-p-code"
                    class="form-control input-code"
                  />
                </div>
                <span v-if="errors.code1" class="text-danger float-left small error-danger">
                  <strong>{{ errors.code1 }}</strong>
                </span>
                <button
                  v-if="show.gifting"
                  class="btn btn-danger btn-sm mt-2 mb-2 pl-4 pr-4"
                  @click="openModal()"
                  aria-hidden="true"
                  type="button"
                >
                  Quiero mi regalo
                </button>
                <p class="info-promo">
                  Ingresa aquí si tienes un código promocional
                </p>
                <div class="input-group mb-2">
                  <input
                    id="i-p-code"
                    placeholder="Código promocional"
                    v-model="codePromotional"
                    type="text"
                    autocomplete="i-p-code"
                    class="form-control input-code"
                  />
                </div>
              </form> -->
            </div>

            <!-- <div
              class="col-12 col-md-12 col-lg-6 col-xl-6"
              style="background-color: #ffffff14; border-radius: 6px; padding-top: 10px;
            padding-bottom: 4px"
            >
              <div class="title-profile-a">
                <label
                  ><b
                    >Tus oportunidades de ganar la moto de tus sueños con
                    Havoline MotoClub</b
                  ></label
                >
              </div>
              <div class="points">
                <h1 class="text-points">{{ eventPoints }}</h1>
              </div>
              <label class="text-color-1" style="text-align: left; font-size: 12px;">
                * Códigos ingresados entre el 15 de abril y el 31 de agosto
              </label>
            </div> -->
          </div>
          <div
            class="row padding-sm-code justify-content-center justify-content-sm-center justify-content-md-center justify-content-lg-center justify-content-xl-center"
          >
            <div class="col-12 col-md-12 col-lg-6 col-xl-6">
              <form autocomplete="off">
                <div class="input-group">
                  <input
                    :class="{ 'is-danger': errors.emailReferred1 }"
                    :hidden="hidden.referred"
                    placeholder="Soy referido de"
                    v-model="emailReferred"
                    type="text"
                    class="form-control input-code"
                  />
                </div>
              </form>
              <span
                v-if="errors.emailReferred1"
                class="text-danger float-left small error-danger mb-3"
                >{{ errors.emailReferred1 }}</span
              >
              <!-- <button
                :disabled="disableLoading"
                @click="validateSendBtn()"
                type="button"
                class="btn btn-danger btn-md btn-block button-send-code mt-3"
              >
                <span
                  v-if="disableLoading"
                  class="spinner-border spinner-border-md"
                  role="status"
                  aria-hidden="true"
                ></span>
                <strong v-else>Enviar</strong>
              </button>
              <p class="pt-2 text-small text-left">
                Entre más códigos registres, más beneficios puedes redimir.
              </p> -->
              <button
                class="btn btn-danger btn-block mb-3"
                data-toggle="modal"
                data-target="#compartirModal"
                aria-hidden="true"
              >
                Referidos havoline
              </button>
              <!-- <h5>
                <span
                  style="width:100%; height:25px"
                  @click="openHistory()"
                  class="badge badge-primary float-left btn-history-s"
                  >Revisa el historial de tus códigos</span
                >
              </h5> -->
              <h5>
                <span
                  style="width:100%; height:25px"
                  @click="openShopping()"
                  class="mt-3 badge badge-danger float-left btn-history"
                  >Revisa el historial de tus compras</span
                >
              </h5>
              <h5>
                <span
                  style="width:100%; height:25px"
                  @click="openAccount()"
                  class="mt-3 badge badge-primary float-left btn-history-s"
                  >Revisa tu estado de cuenta
                </span>
              </h5>
              <h5 v-if="dataUser.role_id == 4 || dataUser.role_id == 5">
                <span
                  style="width:100%; height:25px"
                  @click="openLicense()"
                  class="mt-3 badge badge-danger float-left btn-history"
                  >Ver mi carnet del MotoClub
                </span>
              </h5>
              <!-- <h5>
                <span
                  style="width:100%; height:25px"
                  @click="openRanking()"
                  class="mt-3 badge badge-primary float-left btn-history-s"
                  >Ver ranking havoline players <span class="fa-solid fa-ranking-star"></span>
                </span>
              </h5> -->
              <!-- <h5 v-if="device">
                <span
                  style="width:100%; height:25px"
                  @click="showGame()"
                  class="mt-3 badge badge-danger float-left btn-history"
                  >Jugar <span class="fa-solid fa-flag-checkered"></span>
                </span>
              </h5> -->
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal ingreso de códigos -->
    <template v-if="history">
      <div class="content-history" id="content-history-id">
        <div class="row justify-content-center align-items-center h-100">
          <div class="col-12 col-md-10 col-lg-9 col-xl-9 col-sm-12">
            <div class="row justify-content-between">
              <div class="col-10 col-md-10 col-lg-8 col-xl-7 col-sm-10">
                <h1 class="subtitle-h mt-2 mb-4">
                  Historial de códigos redimidos.
                </h1>
              </div>
              <div class="col-2 col-md-1 col-lg-1 col-xl-1 col-sm-1">
                <h1
                  style="text-align: right; cursor: pointer;"
                  class="subtitle-h mt-2"
                  @click="history = false"
                >
                  <i class="fa fa-times text-danger" aria-hidden="true"></i>
                </h1>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-10 col-lg-9 col-xl-9 col-sm-12">
            <template v-if="alert.status">
              <div class="alert alert-primary " role="alert">
                {{ alert.message }}
              </div>
            </template>
            <div v-else class="row">
              <div v-for="item in listHistory" :key="item.id">
                <div class="col-12 col-md-12 mb-3 col-xl-6 col-lg-6">
                  <div class="card card-history-c">
                    <div class="row ">
                      <div
                        class="col-12 col-md-4 col-xl-4 col-lg-4 col-md-4 mt-4"
                      >
                        <img
                          class="ml-0 ml-md-5 ml-lg-2 ml-xl-4"
                          width="100px"
                          height="100px"
                          src="../../assets/icon/Recurso 3.png"
                          alt="Compra productos Havoline 4T*"
                        />
                      </div>
                      <div class="col-12 col-md-8 col-xl-8 col-md-8 col-lg-8">
                        <div class="card-body">
                          <p
                            style="color: #1da5df; text-align: initial; margin: 5px"
                          >
                            <strong> {{ item.point }} punto(s)</strong>
                          </p>
                          <p
                            style="color: #dc3545; text-align: initial; margin: 5px"
                          >
                            <small class="text-muted"># {{ item.num }}</small>
                          </p>
                          <p
                            style="color: #dc3545; text-align: initial; margin: 5px"
                          >
                            <small class="text-muted">
                              Fecha de redimido {{ item.date }}</small
                            >
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <!-- Fin modal ingreso de códigos -->

    <!-- Modal historial de compras -->
    <template v-if="shopping">
      <div class="content-history" id="content-history-id">
        <div class="row justify-content-center align-items-center h-100">
          <div class="col-12 col-md-10 col-lg-10 col-xl-10 col-sm-12">
            <div class="row justify-content-between">
              <div class="col-10 col-md-10 col-lg-9 col-xl-8 col-sm-10">
                <h1 class="subtitle-h mt-2 mb-4">Historial de compras</h1>
              </div>
              <div class="col-2 col-md-1 col-lg-1 col-xl-1 col-sm-1">
                <h1
                  style="text-align: right; cursor: pointer;"
                  class="subtitle-h mt-2"
                  @click="shopping = false"
                >
                  <i class="fa fa-times text-danger" aria-hidden="true"></i>
                </h1>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-10 col-lg-10 col-xl-10 col-sm-12">
            <template v-if="alert.status">
              <div class="alert alert-primary " role="alert">
                {{ alert.message }}
              </div>
            </template>
            <div v-else class="table-responsive">
              <div class="row">
                <div v-for="item in listShopping" :key="item.id">
                  <div class="col-12 col-xl-4 mb-3">
                    <div class="card card-history-s">
                      <div class="row ">
                        <div class="col-12 col-md-4 col-xl-4 mt-4">
                          <img
                            id="img_product"
                            class="rounded-circle"
                            :src="item.img"
                            :title="item.name"
                          />
                        </div>
                        <div class="col-12 col-md-8 col-xl-8 col-md-8">
                          <div class="card-body">
                            <p
                              style="color: #1da5df; text-align: initial; margin: 5px"
                            >
                              <strong>{{ item.name }}</strong>
                            </p>
                            <p
                              style="color: #dc3545; text-align: initial; margin: 5px"
                            >
                              <small class="text-muted"
                                >Compra el {{ item.created_at }}</small
                              >
                            </p>
                            <p
                              style="color: #dc3545; text-align: initial; margin: 5px"
                            >
                              <small class="text-muted"
                                >{{ item.points }} puntos</small
                              >
                            </p>
                            <p
                              v-if="item.statusDes == 'Rechazado'"
                              style="color: #fff; text-align: initial; margin: 5px"
                            >
                              <span class="badge bg-danger"
                                >{{ item.statusDes }}
                              </span>
                            </p>

                            <p
                              v-else
                              style="color: #fff; text-align: initial; margin: 5px"
                            >
                              <span class="badge bg-info"
                                >{{ item.statusDes }}
                              </span>
                            </p>

                            <button
                              @click="openModalDetails(item)"
                              class="btn btn-block btn-outline-danger"
                            >
                              <template v-if="loading.btn">
                                <span
                                  class="spinner-border spinner-border-sm"
                                  role="status"
                                  aria-hidden="true"
                                ></span>
                                <span class="visually-hidden">Loading...</span>
                              </template>
                              <template v-else>
                                VER DETALLES
                              </template>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <!-- Fin modal historial de compras -->

    <!-- Modal carnet del Motero -->
    <template v-if="dataUser.role_id == 4 || dataUser.role_id == 5">
      <template v-if="showLicense">

        <div class="row justify-content-center">
          <div id="content_title_carnet">
            <h1 style="text-align:center !important;" class="title_carnet">Tú carnet del MotoClub</h1>
            <div>
              <h1
                style="text-align:center; cursor:pointer;"
                class="title_carnet"
                @click="showLicense = false"
              >
                <i class="fa fa-times text-danger" aria-hidden="true"></i>
              </h1>
            </div>
          </div>
        </div>

        <template>
          <div id="content_carnet">
            <div id="user_data_carnet">
              <div class="data_carnet">
                <span class="name_and_last_name">
                  <strong style="color:white; text-align:initial;">
                    {{ dataUser.name }} {{ dataUser.last_name }}
                  </strong>
                </span>
                <span class="cc_and_document">
                  <span style="display:inline-flex; color:white; text-align:initial;">
                    {{ dataUser.document_type.name }}: {{ dataUser.document_number }}
                  </span>
                </span>
                <span class="user_role">
                  <strong style="color:white;">Tipo de usuario:&nbsp;</strong>
                  <span style="color:white; text-align: initial;">
                    {{ dataUser.role_id == 4 ? 'Lubricador' : dataUser.role_id == 5 ? 'Motero' : '' }}
                  </span>
                </span>
                <span class="user_plate" v-if="dataUser.role_id == 5">
                  <strong style="color:white;">Placa:&nbsp;</strong>
                  <span style="color:white; text-align: initial;">
                    {{ dataUser.plate }}
                  </span>
                </span>
                <span class="user_city">
                  <strong style="color:white;">Ciudad:&nbsp;</strong>
                  <span style="color:white; text-align: initial;">
                    {{ dataUser.city.name }}
                  </span>
                </span>
                <div class="user_activo">
                  <strong class="miembro_activo">{{ dataUser.status.description.toUpperCase() }}</strong><br>
                  <span class="havoline_motoclub">HAVOLINE MOTOCLUB</span>
                </div>
                <hr class="red_line"><br>

                <div class="qr_code">
                  <qr-code 
                    :text="urlUserAlliance + dataUser.id"
                    :size="140"
                  ></qr-code>
                </div>
                <div class="info_adicional">
                  <span style="color:white; font-size:12px;">
                    Este carnet es personal e intransferible y no podrá ser usado sin autorización del titular del ID.
                  </span>
                </div>
              </div>
            </div>
          </div>
          <button
            @click="downloadPDF()"
            class="btn btn-block btn-outline-danger"
            id="btn_download_carnet"
          >
            <template v-if="loading.btn">
              <span class="visually-hidden">Descargando...</span>&nbsp;
              <span
                class="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true">
              </span>
            </template>
            <template v-else>
              Descargar
            </template>
          </button>
        </template>
      </template>
    </template>
    <!-- Fin modal carnet del Motero -->

    <!-- Modal ranking -->
    <template v-if="ranking">
      <div class="content-history" id="content-history-id">
        <div class="row justify-content-center align-items-center h-100">
          <div class="col-12 col-md-10 col-lg-9 col-xl-9 col-sm-12">
            <div class="row justify-content-between">
              <div class="col-10 col-md-10 col-lg-8 col-xl-7 col-sm-10">
                <h1 class="subtitle-h mt-2 mb-4">
                  Ranking Moteros - <strong class="distName">{{ distRanking }}</strong>
                </h1>
              </div>
              <div class="col-2 col-md-1 col-lg-1 col-xl-1 col-sm-1">
                <h1
                  style="text-align: right; cursor: pointer;"
                  class="subtitle-h mt-2"
                  @click="ranking = false"
                >
                  <i class="fa fa-times text-danger" aria-hidden="true"></i>
                </h1>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-10 col-lg-9 col-xl-9 col-sm-12">
            <div class="row">
              <table class="table table-striped">
                <caption class="visually-hidden">Ranking</caption>
                <thead>
                  <tr>
                    <th scope="col">Puesto</th>
                    <th scope="col">Nombre</th>
                    <th scope="col">Puntos</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, i) in listRanking" :key="item.id">
                    <th scope="row"><strong style="color:#dc3545"> {{ i + 1 }} </strong></th>
                    <th scope="row">
                      <strong style="color:#1da5df">
                        <span class="name-container">
                          {{ item.id === dataUser.id ? item.name : hideName(item.name) }}
                          <span v-if="item.id === dataUser.id" class="bubble">¡Eres tú!</span>
                        </span>
                      </strong>
                    </th>
                    <th scope="row"><strong style="color:#dc3545"> {{ item.total_points }} </strong></th>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="ranking_notice">
              <strong class="warning">Aviso importante:</strong>
              <p class="text_warning">Los puntos reflejados en el ranking corresponden a los códigos inscritos desde el
                15 de septiembre del 2024 hasta el 15 de diciembre del mismo año, estos puntos no serán descontados del 
                ranking al momento de ser usados en la redención de productos del catálogo, pero sí se descontarán del 
                puntaje disponible.
              </p>
            </div>
          </div>
        </div>
      </div>
    </template>
    <!-- Fin modal ranking -->

    <!-- Modal game -->
    <template v-if="game">
      <div class="content-history" id="content-history-id">
        <div class="row justify-content-center align-items-center h-100">
          <div class="col-12 col-md-10 col-lg-9 col-xl-9 col-sm-12">
            <div class="row justify-content-between">
              <div class="col-10 col-md-10 col-lg-8 col-xl-7 col-sm-10">
                <h1 class="subtitle-h mt-2 mb-4">
                  ¡A jugar!
                </h1>
              </div>
              <div class="col-2 col-md-1 col-lg-1 col-xl-1 col-sm-1">
                <h1
                  style="text-align: right; cursor: pointer;"
                  class="subtitle-h mt-2"
                  @click="game = false"
                >
                  <i class="fa fa-times text-danger" aria-hidden="true"></i>
                </h1>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-10 col-lg-9 col-xl-9 col-sm-12">
            <div class="col section_game">
              <game @finPartida="saveScore"></game>
            </div>
          </div>
        </div>
      </div>
    </template>
    <!-- Fin modal game -->

    <template v-if="loading.list">
      <div
        class="spinner-border text-danger"
        style="width: 3rem; height: 3rem;"
        role="status"
      >
        <span class="sr-only">Loading...</span>
      </div>
    </template>

    <!-- Modal Cambio password-->
    <div
      class="modal fade"
      id="exampleModalPassword"
      tabindex="-1"
      aria-labelledby="exampleModalPasswordLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5
              class="modal-title"
              id="exampleModalPasswordLabel"
              style="color: #595959"
            >
              <strong>Cambiar contraseña</strong>
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <div class="input-group mb-3">
                <input
                  placeholder="Escribe aquí la contraseña actual"
                  :class="{ 'is-danger': errors.currentPassword }"
                  type="password"
                  ref="current_password"
                  v-model="form.currentPassword"
                  class="form-control"
                  id="exampleFormControlTextarea1"
                />
                <div @click="showPass(1)" class="eye_pass">
                  <span id="pass1" class="fa-regular fa-eye-slash"></span>
                </div>
              </div>
              <div style="text-align: right">
                <span
                  v-if="errors.currentPassword"
                  class="text-danger float-left small error-danger mb-2"
                  >{{ errors.currentPassword }}</span
                >
              </div>
            </div>

            <div class="form-group">
              <div class="input-group mb-3">
                <input
                  placeholder="Escribe aquí la nueva contraseña"
                  :class="{ 'is-danger': errors.pass }"
                  type="password"
                  ref="password"
                  v-model="form.pass"
                  class="form-control"
                  id="exampleFormControlTextarea1"
                />
                <div @click="showPass(2)" class="eye_pass">
                  <span id="pass2" class="fa-regular fa-eye-slash"></span>
                </div>
              </div>
              <div style="text-align: right">
                <span
                  v-if="errors.pass"
                  class="text-danger float-left small error-danger mb-2"
                  >{{ errors.pass }}</span
                >
              </div>
            </div>

            <div class="form-group">
              <div class="input-group mb-3">
                <input
                  placeholder="Escribe aquí la confirmación de la contraseña"
                  :class="{ 'is-danger': errors.pass_confirmation }"
                  type="password"
                  ref="confirm_password"
                  v-model="form.pass_confirmation"
                  class="form-control"
                  id="exampleFormControlTextarea1"
                />
                <div @click="showPass(3)" class="eye_pass">
                  <span id="pass3" class="fa-regular fa-eye-slash"></span>
                </div>
              </div>
              <div style="text-align: right">
                <span
                  v-if="errors.pass_confirmation"
                  class="text-danger float-left small error-danger mb-2"
                  >{{ errors.pass_confirmation }}</span
                >
              </div>
            </div>
          </div>
          <div class="modal-footer" style="justify-content: center">
            <button
              type="button"
              class="btn "
              style="background-color: #AAA; color: #fff;"
              data-dismiss="modal"
            >
              Cancelar
            </button>
            <button
              type="button"
              class="btn btn-danger"
              @click="changePassword()"
            >
              Actualizar
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal actualización de datos -->
    <div
      v-if="dataUser.role_id == 4 || dataUser.role_id == 5"
      class="modal fade"
      id="exampleModalUpdate"
      tabindex="-1"
      aria-labelledby="exampleModalUpdateLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5
              class="modal-title"
              id="exampleModalUpdateLabel"
              style="color:#595959"
            >
              <strong>Actualizar datos</strong>
            </h5>
            <button
              type="button"
              class="close close_update"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12">
                <div class="form-group" style="text-align: left">
                  <small style="color: #595959 ">Tipo de documento *</small
                  ><br />
                  <div class="input-group mb-3 ">
                    <select
                      v-model="dataUser.document_type_id"
                      class="form-control"
                      :class="{ 'is-danger': errors.document_type_id }"
                      id="exampleFormControlSelect1"
                      placeholder="Tipo de documento *"
                      disabled
                    >
                      <option value="0" disabled selected
                        >Tipo de documento *</option
                      >
                      <option
                        v-for="(item, i) in listTypeDocuments"
                        :key="'td' + i"
                        :value="item.id"
                      >
                        {{ item.name }}
                      </option>
                    </select>
                  </div>
                  <span
                    v-if="errors.document_type_id"
                    class="text-danger float-left small error-danger"
                    >{{ errors.document_type_id }}</span
                  >
                </div>
              </div>
              <div class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12">
                <div class="form-group" style="text-align: left">
                  <small style="color: #595959 ">Número de documento *</small
                  ><br />
                  <div class="input-group mb-3">
                    <input
                      placeholder="Ingresa aquí tu número de documento"
                      :class="{ 'is-danger': errors.document_number }"
                      type="text"
                      v-model="dataUser.document_number"
                      class="form-control"
                      id="exampleFormControlTextarea1"
                      disabled
                    />
                  </div>
                  <div style="text-align: right">
                    <span
                      v-if="errors.document_number"
                      class="text-danger float-left small error-danger mb-2"
                      >{{ errors.document_number }}</span
                    >
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12">
                <div class="form-group" style="text-align: left">
                  <small style="color: #595959 ">Nombres *</small><br />
                  <div class="input-group mb-3">
                    <input
                      placeholder="Ingresa aquí tus nombres"
                      :class="{ 'is-danger': errors.name }"
                      type="text"
                      v-model="dataUser.name"
                      class="form-control"
                      id="exampleFormControlTextarea1"
                    />
                  </div>
                  <div style="text-align: right">
                    <span
                      v-if="errors.name"
                      class="text-danger float-left small error-danger mb-2"
                      >{{ errors.name }}</span
                    >
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12">
                <div class="form-group" style="text-align: left">
                  <small style="color: #595959 ">Apellidos *</small><br />
                  <div class="input-group mb-3">
                    <input
                      placeholder="Ingresa aquí tus apellidos"
                      :class="{ 'is-danger': errors.last_name }"
                      type="text"
                      v-model="dataUser.last_name"
                      class="form-control"
                      id="exampleFormControlTextarea1"
                    />
                  </div>
                  <div style="text-align: right">
                    <span
                      v-if="errors.last_name"
                      class="text-danger float-left small error-danger mb-2"
                      >{{ errors.last_name }}</span
                    >
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12">
                <div class="form-group" style="text-align: left">
                  <small style="color: #595959 ">Departamento *</small><br />

                  <div class="input-group  mb-3">
                    <select
                      v-model="dataUser.state_id"
                      class="form-control"
                      :class="{ 'is-danger': errors.state_id }"
                      id="exampleFormControlSelect1"
                    >
                      <option disabled value="0" selected>Departamento</option>
                      <option
                        v-for="(item, i) in listDocuments"
                        :value="item.id"
                        :key="'st' + i"
                      >
                        {{ item.name }}
                      </option>
                    </select>
                  </div>
                  <span
                    v-if="errors.state_id"
                    class="text-danger float-left small error-danger"
                    >{{ errors.state_id }}</span
                  >
                </div>
              </div>
              <div class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12">
                <div class="form-group" style="text-align: left">
                  <small style="color: #595959 ">Ciudad *</small><br />

                  <div class="input-group mb-3">
                    <select
                      v-model="dataUser.city_id"
                      class="form-control"
                      :class="{ 'is-danger': errors.city_id }"
                      id="exampleFormControlSelect1"
                    >
                      <option value="0" disabled selected>Ciudad *</option>
                      <option
                        v-for="(item, i) in listCities"
                        :key="'ci' + i"
                        :value="item.id"
                      >
                        {{ item.name }}
                      </option>
                    </select>
                  </div>
                  <span
                    v-if="errors.city_id"
                    class="text-danger float-left small error-danger"
                    >{{ errors.city_id }}</span
                  >
                </div>
              </div>
              <div class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12">
                <div class="form-group" style="text-align: left">
                  <small style="color: #595959 ">Placa </small><br />
                  <div class="input-group mb-3">
                    <input
                      placeholder="Ingresa aquí la placa"
                      type="text"
                      v-model="dataUser.plate"
                      class="form-control"
                      id="exampleFormControlTextarea1"
                    />
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12">
                <div class="form-group" style="text-align: left">
                  <small style="color: #595959 ">Dirección</small><br />

                  <div class="input-group mb-3">
                    <input
                      placeholder="Ingresa aquí la dirección"
                      :class="{ 'is-danger': errors.pass }"
                      type="text"
                      v-model="dataUser.address"
                      class="form-control"
                      id="exampleFormControlTextarea1"
                    />
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12">
                <div class="form-group" style="text-align: left">
                  <small style="color: #595959 ">Teléfono *</small><br />
                  <div class="input-group mb-3">
                    <input
                      placeholder="Ingresa aquí tu teléfono"
                      :class="{ 'is-danger': errors.phone }"
                      type="text"
                      v-model="dataUser.phone"
                      class="form-control"
                      id="exampleFormControlTextarea1"
                    />
                  </div>
                  <div style="text-align: right">
                    <span
                      v-if="errors.phone"
                      class="text-danger float-left small error-danger mb-2"
                      >{{ errors.phone }}</span
                    >
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12">
                <div class="form-group" style="text-align: left">
                  <small style="color: #595959 ">Género *</small><br />
                  <div class="input-group mb-3 ">
                    <select
                      v-model="dataUser.gender_id"
                      class="form-control"
                      :class="{ 'is-danger': errors.genderId }"
                      id="exampleFormControlSelect1"
                      placeholder="Ingresa aquí el género *"
                    >
                      <option value="4" disabled selected
                        >Ingresa aquí el género *</option
                      >
                      <option
                        v-for="(item, i) in listGenders"
                        :key="'td' + i"
                        :value="item.id"
                        class="color-option"
                      >
                        {{ item.name }}
                      </option>
                    </select>
                  </div>
                  <span
                    v-if="errors.genderId"
                    class="text-danger float-left small error-danger"
                    >{{ errors.genderId }}</span
                  >
                </div>
              </div>
              <div class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12">
                <div class="form-group" style="text-align: left">
                  <small style="color: #595959 ">Email *</small><br />
                  <div class="input-group mb-3">
                    <input
                      placeholder="Ingresa aquí tu correo"
                      :class="{ 'is-danger': errors.email }"
                      type="text"
                      v-model="dataUser.email"
                      class="form-control"
                    />
                  </div>
                  <div style="text-align: right">
                    <span
                      v-if="errors.email"
                      class="text-danger float-left small error-danger mb-2"
                      >{{ errors.email }}</span
                    >
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12">
                <div class="form-group" style="text-align: left">
                  <small style="color: #595959 ">Fecha de nacimiento *</small><br />
                  <div class="input-group mb-3">
                    <input
                      :class="{ 'is-danger': errors.birthdate }"
                      type="text"
                      v-model="dataUser.birthdate"
                      class="form-control"
                      placeholder="fecha de nacimiento *"
                      :min="minDate()"
                      :max="maxDate()"
                      onfocus="(this.type='date')"
                    />
                  </div>
                  <div style="text-align: right">
                    <span
                      v-if="errors.email"
                      class="text-danger float-left small error-danger mb-2"
                      >{{ errors.email }}</span
                    >
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12">
                <div class="form-group" style="text-align:left">
                  <small style="color: #595959">Marca de tu moto *</small>
                  <div class="input-group mb-3">
                    <select
                      v-model="dataUser.motorcycle_brands_id"
                      class="form-control"
                      :class="{ 'is-danger': errors.motorcycleBrand }"
                      id="motorcycleBrand"
                    >
                      <option v-for="item in listBrands" :key="item.id" :value="item.id" class="color-option" >
                        {{ item.description }}
                      </option>
                    </select>
                  </div>
                  <span
                      v-if="errors.motorcycleBrand"
                      class="text-danger float-left small error-danger"
                  >{{ errors.motorcycleBrand }}</span
                  >
                </div>
              </div>
              <div v-if="dataUser.motorcycle_brands_id == 44" class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12">
                <div class="form-group" style="text-align:left">
                  <small style="color: #595959">¿Cúal? *</small>
                  <div class="input-group mb-3">
                    <input
                      :class="{ 'is-danger': errors.motorcycleBrandOther }"
                      v-model="dataUser.motorcycle_brand_other"
                      type="text"
                      class="form-control"
                      aria-label="text"
                      placeholder="¿Cúal? (Escriba la marca de su moto) *"
                      aria-describedby="basic-addon1"
                    />
                  </div>
                  <span
                      v-if="errors.motorcycleBrandOther"
                      class="text-danger float-left small error-danger"
                  >{{ errors.motorcycleBrandOther }}</span
                  >
                </div>
              </div>
              <div class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12">
                <div class="form-group" style="text-align:left">
                  <small style="color: #595959">Cilindraje de tu moto *</small>
                  <div class="input-group mb-3">
                    <select
                        v-model="dataUser.motorcycle_cylinder_sizes_id"
                        class="form-control"
                        :class="{ 'is-danger': errors.motorcycleCylinder }"
                        id="motorcycleCylinder"
                    >
                      <option v-for="item in listCylinders" :key="item.id" :value="item.id" class="color-option" >
                        {{ item.description }}
                      </option>
                    </select>
                  </div>
                  <span
                      v-if="errors.motorcycleCylinder"
                      class="text-danger float-left small error-danger"
                  >{{ errors.motorcycleCylinder }}</span
                  >
                </div>
              </div>
              <div class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12">
                <div class="form-group" style="text-align:left">
                  <small style="color: #595959">Uso de tu moto *</small>
                  <div class="input-group mb-3">
                    <select
                        v-model="dataUser.motorcycle_uses_id"
                        class="form-control"
                        :class="{ 'is-danger': errors.motorcycleUse }"
                        id="motorcycleUse"
                    >
                      <option v-for="item in listUses" :key="item.id" :value="item.id" class="color-option" >
                        {{ item.description }}
                      </option>
                    </select>
                  </div>
                  <span
                      v-if="errors.motorcycleUse"
                      class="text-danger float-left small error-danger"
                  >{{ errors.motorcycleUse }}</span
                  >
                </div>
              </div>
              <div class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12"
                v-if="dataUser.motorcycle_uses_id == 4"
              >
                <div class="form-group" style="text-align:left">
                  <small style="color: #595959">¿Cúal? *</small>
                  <div class="input-group mb-3">
                    <input
                      :class="{ 'is-danger': errors.motorcycleUseOther }"
                      v-model="dataUser.motorcycle_use_other"
                      type="text"
                      class="form-control"
                      aria-label="text"
                      placeholder="¿Cúal? (Escriba el uso de su moto) *"
                      aria-describedby="basic-addon1"
                    />
                  </div>
                  <span
                      v-if="errors.motorcycleUseOther"
                      class="text-danger float-left small error-danger"
                  >{{ errors.motorcycleUseOther }}</span
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer" style="justify-content: center">
            <button
              type="button"
              class="btn btn_cancel"
              style="background-color: #AAA; color: #fff;"
              data-dismiss="modal"
            >
              Cancelar
            </button>

            <button
              :disabled="disableLoadingSend"
              type="button"
              @click="validateUpdate()"
              class="btn btn-danger"
              id="btn-register-id"
            >
              <span
                v-if="disableLoadingSend"
                class="spinner-border spinner-border-md"
                role="status"
                aria-hidden="true"
              ></span>
              <template v-else>Actualizar</template>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <div
      class="modal fade"
      id="exampleModalDetailsM1"
      tabindex="-1"
      aria-labelledby="exampleModalDetailsMLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5
              class="modal-title"
              id="exampleModalDetailsMLabel"
              style="color: #595959"
            >
              <strong>Estado del pedido</strong>
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <vue-step
              active-color="#DC3545"
              style-type="style1"
              direction="vertical"
              :now-step="nowStep"
              :step-list="stepList"
            ></vue-step>
            <small>
              Código de rastreo
            </small>
          </div>
          <div class="modal-footer" style="justify-content: center">
            <button
              type="button"
              class="btn btn-lg"
              style="background-color: #AAA; color: #fff;"
              data-dismiss="modal"
            >
              Cancelar
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Detalles-->
    <div class="modal" id="loadingModal" tabindex="-1">
      <div
        class="spinner-border text-danger loading-modal"
        style="width: 6rem; height: 6rem;"
        role="status"
      ></div>
    </div>

    <div
      class="modal fade"
      id="exampleModalDetailsM"
      tabindex="-1"
      aria-labelledby="exampleModalDetailsMLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5
              class="mt-2"
              id="exampleModalDetailsMLabel"
              style="color:#dc3545; min-width:100%;"
            >
              <strong>Detalles de la compra</strong>
            </h5>
            <button
              id="close_detail_product"
              type="button"
              class="close pt-4"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body mb-4">
            <div class="row ">
              <div class="col-12 col-md-4 col-xl-4 col-md-4 mt-0">
                <img
                  class="rounded-circle"
                  width="140px"
                  height="140px"
                  :src="purchaseData.img"
                  alt="Compra productos Havoline 4T*"
                />
              </div>
              <div class="col-12 col-md-8 col-xl-8 col-md-8">
                <div class="card-body">
                  <p style="color: #1da5df; text-align: initial; margin: 1px">
                    <strong>{{ purchaseData.name }}</strong>
                  </p>
                  <p style="color:#dc3545; text-align:initial; margin:1px">
                    <small class="text-muted"
                      >Compra el {{ purchaseData.created_at }}</small
                    >
                  </p>

                  <p style="color: #dc3545; text-align: initial; margin: 1px">
                    <small class="text-muted"
                      >{{ purchaseData.points }} puntos</small
                    >
                  </p>
                </div>
              </div>
              <div class="col-12">
                <p style="color: #dc3545; text-align: initial; margin: 1px">
                  <small class="text-muted">{{
                    purchaseData.description
                  }}</small>
                </p>
                <template v-if="purchaseData.product_type_id == 6">
                  <template v-if="loading.descriptionAll">
                    <div
                      class="spinner-border text-danger"
                      style="width: 5rem; height: 5rem;"
                      role="status"
                    >
                      <span class="sr-only">Loading...</span>
                    </div>
                  </template>
                  <template v-else>
                    <template v-if="purchaseData.bonus_id != null">
                      <p class="text-left text-dark fs-5 font-weight-bold mt-3">
                        INFORMACIÓN DEL BONO
                      </p>

                      <div v-if="purchaseData.showBtn">
                        <button
                          @click="downloadBonus(purchaseData)"
                          class="btn btn-danger"
                        >
                          DESCARGAR
                        </button>
                      </div>
                      <div v-else>
                        <h1>
                          <span class="badge badge-danger">
                            {{ purchaseData.bonus_id }}
                          </span>
                        </h1>
                      </div>
                    </template>
                    <p
                      style="color: #6e767e; text-align: initial; margin-top: 5px pt-4"
                    >
                      Detalle de redención:
                    </p>
                    <p
                      style="color: #6e767e; text-align: initial; margin-top: 5px pt-4"
                    >
                      {{ purchaseData.descrip }}
                    </p>
                  </template>
                </template>

                <hr />
                <template v-if="purchaseData.product_type_id == 4">
                  <p
                    style="color: #1da5df; text-align: center; font-size: 30px; margin-bottom: 0rem;"
                  >
                    <strong>{{ purchaseData.code }}</strong>
                  </p>
                  <barcode :value="purchaseData.code" displayValue="false">
                    Error al cargar el código de barras.
                  </barcode>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Compartir-->
    <div
      class="modal fade"
      id="compartirModal"
      tabindex="-1"
      aria-labelledby="compartirModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content compartirModal">
          <div class="modal-body">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <i class="fa fa-times-circle text-light" aria-hidden="true"></i>
            </button>
            <div class="row justify-content-center">
              <div class="mt-3 row justify-content-center">
                <div class="col-12">
                  <label style="color: #fdd200;">
                    <span>
                      <strong>
                        Refiere a tus amigos para que ninguno se quede por fuera
                        del MotoClub.</strong
                      >
                    </span>
                  </label>
                  <br />
                </div>
                <div class="col-12">
                  <strong
                    >Ingresa el correo electrónico de la persona que quieres
                    referir e invítalos a registrarse. <br />
                    ¡Entre más personas invites, más puntos puedes ganar!</strong
                  >
                </div>
                <div class="mt-4 col-10 col-md-11 col-lg-5 col-xl-5 col-sm-10">
                  <div class="form-group">
                    <div class="input-group mb-3">
                      <input
                        :class="{ 'is-danger': errors.shareEmail }"
                        @keyup.enter="addEmailShare()"
                        v-model="shareEmail"
                        type="text"
                        class="form-control color-input-shared"
                        aria-label="Email"
                        placeholder="CORREO ELECTRÓNICO"
                        aria-describedby="basic-addon1"
                      />
                    </div>
                    <span
                      v-if="errors.shareEmail"
                      class="text-light float-left small error-danger mb-3"
                      style="text-align: initial;"
                      >{{ errors.shareEmail }}</span
                    >
                  </div>
                </div>
              </div>
              <div class="row justify-content-end">
                <div class="col-12 col-md-12 col-lg-9 col-xl-9 col-sm-12">
                  <div
                    class="btn-toolbar"
                    role="toolbar"
                    aria-label="Toolbar with button groups"
                  >
                    <div
                      class="btn-group mr-2 pl-0 pl-md-4 pl-xl-4 pl-lg-4"
                      role="group"
                      aria-label="First group"
                    >
                      <button
                        @click="share()"
                        type="button"
                        class="btn btn-dark button-shared"
                      >
                        <span
                          v-if="disableLoading"
                          class="spinner-border spinner-border-md"
                          role="status"
                          aria-hidden="true"
                          style="width: 1rem; height: 1rem;"
                        ></span>
                        <template v-else><strong>Compartir</strong></template>
                      </button>
                      <div class="rounded-circle circle-email">
                        <span
                          class="fa fa-envelope-o icon-email"
                          style="color: red"
                        ></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <small class="info-shared">
            * Los puntos de obsequio solo serán válidos para usuarios nuevos que
            registren su primer código en el MotoClub.
          </small>
        </div>
      </div>
    </div>

    <!-- MODAL ESTADO DE CUENTA -->
    <div
      class="modal fade"
      id="account-state"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content modal-info-l" style="border-radius: 50px;">
          <div class="modal-body img-account" alt="Imagen">
            <!-- <div class="boton">
              <button
                type="button"
                class="close close-info-l"
                data-dismiss="modal"
                aria-label="Close"
              >
                X
              </button>
            </div> -->
            <div class="row justify-content-center">
              <div class="div-account">
                <h4 class="text-danger mb-0">
                  <span><strong>ESTADO DE CUENTA</strong></span>
                </h4>
              </div>

              <div
                class="col-12 col-sm-8 col-md-9 col-lg-8 col-xl-8 mb-0 mb-xl-5 mb-lg-5 mt-0 mt-xl-5 mt-lg-5"
              >
                <div class="row mt-4 ">
                  <div class="col-12 col-sm-2 col-md-12 col-lg-2 col-xl-2">
                    <p style="text-align: initial;" class="mt-2">
                      <span><strong>DESDE:</strong></span>
                    </p>
                  </div>
                  <div class="col-12 col-sm-3 col-md-4 col-lg-3 col-xl-3">
                    <div class="form-group">
                      <select
                        v-model="infoAccount.monthFrom"
                        class="form-control"
                        id="exampleFormControlSelect1"
                      >
                        <option selected disabled value="null">MES</option>
                        <option
                          :key="data.num"
                          v-for="data in monthFrom"
                          :value="data.num"
                        >
                          {{ data.text }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <div class="col-12 col-sm-3 col-md-4 col-lg-3 col-xl-3">
                    <div class="form-group">
                      <select
                        v-model="infoAccount.dayFrom"
                        class="form-control"
                        id="exampleFormControlSelect1"
                      >
                        <option selected disabled value="null">DÍA</option>
                        <option
                          :key="data"
                          v-for="data in dayFrom"
                          :value="data"
                        >
                          {{ data }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <div class="col-12 col-sm-3 col-md-4 col-lg-3 col-xl-3">
                    <div class="form-group">
                      <select
                        v-model="infoAccount.yearFrom"
                        class="form-control"
                        id="exampleFormControlSelect1"
                      >
                        <option selected disabled value="null">AÑO</option>
                        <option
                          :key="data"
                          v-for="data in yearFrom"
                          :value="data"
                        >
                          {{ data }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>

                <div class="row mt-3">
                  <div class="col-12 col-sm-2 col-md-12 col-lg-2 col-xl-2 ">
                    <p style="text-align: initial;" class="mt-2">
                      <span><strong>HASTA:</strong></span>s
                    </p>
                  </div>
                  <div class="col-12 col-sm-3 col-md-4 col-lg-3 col-xl-3">
                    <div class="form-group">
                      <select
                        v-model="infoAccount.monthUntil"
                        class="form-control"
                        id="exampleFormControlSelect1"
                      >
                        <option selected disabled value="null">MES</option>
                        <option
                          :key="data.num"
                          v-for="data in monthUntil"
                          :value="data.num"
                        >
                          {{ data.text }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <div class="col-12 col-sm-3 col-md-4 col-lg-3 col-xl-3">
                    <div class="form-group">
                      <select
                        v-model="infoAccount.dayUntil"
                        class="form-control"
                        id="exampleFormControlSelect1"
                      >
                        <option selected disabled value="null">DÍA</option>
                        <option
                          :key="data"
                          v-for="data in dayUntil"
                          :value="data"
                        >
                          {{ data }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <div class="col-12 col-sm-3 col-md-4 col-lg-3 col-xl-3">
                    <div class="form-group">
                      <select
                        v-model="infoAccount.yearUntil"
                        class="form-control"
                        id="exampleFormControlSelect1"
                      >
                        <option selected disabled value="null">AÑO</option>
                        <option
                          :key="data"
                          v-for="data in yearUntil"
                          :value="data"
                        >
                          {{ data }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-12 col-sm-3 col-md-3 col-lg-3 col-xl-3">
                <button @click="getAccount()" class="btn btn-get-black">
                  <template v-if="loading.listA">
                    <span
                      class="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    <span class="visually-hidden">Loading...</span>
                  </template>
                  <template v-else>
                    Buscar
                  </template>
                </button>
              </div>

              <div class="col-12 mt-2 mb-4">
                <button @click="downloadAccount()" class="btn btn-down-yellow">
                  <template v-if="loading.btn">
                    <span
                      class="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    <span class="visually-hidden">Loading...</span>
                  </template>
                  <template v-else>
                    Descargar
                  </template>
                </button>&nbsp;
                <button @click="closeModalSA()" class="btn btn-down-yellow">
                  <template>
                    Cerrar
                  </template>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL ESTADO DE CUENTA TABLA -->
    <div
      class="modal fade"
      id="account-state-get"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content modal-info-l" style="border-radius: 50px;">
          <div class="modal-body img-account" alt="Imagen">
            <!-- <div class="boton">
              <button
                type="button"
                class="close close-info-l"
                data-dismiss="modal"
                aria-label="Close"
              >
                X
              </button>
            </div> -->
            <div class="row justify-content-center">
              <div class="div-account">
                <h4 class="text-danger mb-0">
                  <span><strong>ESTADO DE CUENTA</strong></span>
                </h4>
              </div>
            </div>

            <div class="row justify-content-center mt-5">
              <div class="col-11 table-account">
                <template v-if="loading.listA">
                  <div class="pr-5 pt-5" style="text-align: center">
                    <div
                      class="spinner-border text-danger"
                      style="width: 5rem; height: 5rem;"
                      role="status"
                    ></div>
                  </div>
                </template>

                <div v-else class="table-responsive">
                  <table class="table table-sm table-account-t">
                    <caption class="visually-hidden">Historial</caption>
                    <thead>
                      <tr>
                        <th class="th-account-1" scope="col">Fecha</th>
                        <th class="th-account" scope="col">
                          Ingreso de códigos
                        </th>
                        <th class="th-account-1" scope="col">
                          Egreso redenciones
                        </th>
                        <th class="th-account" scope="col">Total puntos</th>
                        <th class="th-account-1" scope="col">Detalle</th>
                        <th class="th-account" scope="col">
                          Estado redenciones
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="data in listAccount" :key="data.id">
                        <td scope="row">{{ data.date }}</td>
                        <td>{{ data.total_codes }}</td>
                        <td>{{ data.total_redeems }}</td>
                        <td>{{ data.total_points }}</td>
                        <td>{{ data.detail }}</td>
                        <td>{{ data.status }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div class="col-12 mt-5 mb-4">
                <button @click="downloadAccount()" class="btn btn-down-yellow">
                  <template v-if="loading.btn">
                    <span
                      class="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    <span class="visually-hidden">Loading...</span>
                  </template>
                  <template v-else>
                    Descargar
                  </template>
                </button>&nbsp;
                <button @click="closeModalTSA()" class="btn btn-down-yellow">
                  <template>
                    Cerrar
                  </template>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL DIRECCION -->
    <div
      class="modal fade"
      id="dataSendGif"
      data-backdrop="static"
      data-keyboard="false"
      tabindex="-1"
      aria-labelledby="dataSendGifLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <p class="subtitle-card text-center" style="margin: 0px;">
              DETALLES DEL DESTINATARIO.
            </p>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <formAddress
              @cancel="cancelar($event)"
              @buy="confirmation($event)"
            ></formAddress>
          </div>
        </div>
      </div>
    </div>

    <gifting :result="resuls"> </gifting>
  </div>
</template>

<script>
import vueStep from "vue-step";
import gifting from "../../components/modalGifting.vue";
import $ from "jquery";
import VueBarcode from "vue-barcode";
import { DATE } from "../../config/utils";
import formAddress from "./catalogueEcommerce/formAddress.vue";
import axios from 'axios';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import VueQRCodeComponent from 'vue-qrcode-component'
import GameComponent from '../user/GameComponent.vue'

export default {
  components: {
    formAddress: formAddress,
    vueStep,
    barcode: VueBarcode,
    gifting,
    qrCode: VueQRCodeComponent,
    game: GameComponent
  },
  data() {
    return {
      infoUser: {},
      infoAccount: {
        monthFrom: null,
        dayFrom: null,
        yearFrom: null,
        monthUntil: null,
        dayUntil: null,
        yearUntil: null,
      },
      listAccount: [],
      monthFrom: DATE.month,
      dayFrom: DATE.day,
      yearFrom: DATE.year,
      monthUntil: DATE.month,
      dayUntil: DATE.day,
      yearUntil: DATE.year,
      purchaseData: {},
      hidden: {
        referred: true,
      },
      emailReferred: "",
      listShareEmail: [],
      shareEmail: "",
      eventPoints: "*",
      nowStep: 3,
      stepList: ["Estado 1", "Estado 2", "Estado 3", "Estado 4"],
      listTypeDocuments: [],
      listCities: [],
      listDocuments: [],
      loading: {
        list: false,
        listA: false,
        profile: true,
        btn: false,
        descriptionAll: false,
      },
      alert: {
        status: false,
        message: "",
      },
      history: false,
      shopping: false,
      showLicense: false,
      ranking: false,
      game: false,
      listRanking: [],
      listHistory: [],
      listShopping: [],
      dataUser: [],
      documentUser: "",
      cityUser: "",
      redeemCodes: 0,
      points: "*",
      pointsEvents: "0",
      code1: "",
      disableLoading: false,
      disableLoadingSend: false,
      form: {
        pass: "",
        pass_confirmation: "",
        currentPassword: "",
      },
      errors: {
        shareEmail: false,
        emailReferred1: false,
        email: false,
        pass: false,
        pass_confirmation: false,
        currentPassword: false,
        genderId: false,
        code1: false,
      },
      listGenders: [],
      codePromotional: null,
      resuls: null,
      show: {
        gifting: false,
      },
      eventId: null,
      urlUserAlliance: 'https://havolinemotoclub.com/consulta/alianza/usuario/',
      expired_points: "*",
      device: false,
      distRanking: null,
      ip_address: "8.8.8.8"
    };
  },
  methods: {
    minDate() {
      const now = new Date();
      now.setFullYear(now.getFullYear() - 100);
      return now.toISOString().substr(0, 10);
    },
    maxDate(){
      const now = new Date();
      now.setFullYear(now.getFullYear() - 18);
      return now.toISOString().substr(0, 10);
    },
    getAccount() {
      if (
        this.infoAccount.monthFrom == null &&
        this.infoAccount.yearFrom == null &&
        this.infoAccount.dayFrom == null &&
        this.infoAccount.yearUntil == null &&
        this.infoAccount.monthUntil == null &&
        this.infoAccount.dayUntilFrom == null
      ) {
        this.$swal({
          confirmButtonColor: "#dc3545",
          icon: "error",
          title: "Oops...",
          text: "Debe seleccionar una fecha",
        });
        return false;
      }

      var data = {
        origin: 1,
        initDate:
          this.infoAccount.yearFrom +
          "-" +
          this.infoAccount.monthFrom +
          "-" +
          this.infoAccount.dayFrom,
        finDate:
          this.infoAccount.yearUntil +
          "-" +
          this.infoAccount.monthUntil +
          "-" +
          this.infoAccount.dayUntil,
      };
      this.loading.listA = true;
      axios
        .post("api/statement/account", data)
        .then((res) => {
          this.loading.listA = false;
          if (res.data.cod == 0) {
            $("#account-state-get").modal("show");
            $("#account-state").modal("hide");
            this.listAccount = res.data.data;
          }
        })
        .catch(() => {
          this.closeModal();
          this.loading.listA = false;
        });
    },
    closeModal() {
      $("#account-state-get").modal("hide");
    },
    closeModalSA() {
      $("#account-state").modal("hide");
    },
    closeModalTSA(){
      $("#account-state-get").modal("hide");
    },
    downloadAccount() {
      if (
        this.infoAccount.monthFrom == null &&
        this.infoAccount.yearFrom == null &&
        this.infoAccount.dayFrom == null &&
        this.infoAccount.yearUntil == null &&
        this.infoAccount.monthUntil == null &&
        this.infoAccount.dayUntilFrom == null
      ) {
        this.$swal({
          confirmButtonColor: "#dc3545",
          icon: "error",
          title: "Oops...",
          text: "Debe seleccionar una fecha",
        });
        return false;
      }
      var data = {
        initDate:
          this.infoAccount.yearFrom +
          "-" +
          this.infoAccount.monthFrom +
          "-" +
          this.infoAccount.dayFrom,
        finDate:
          this.infoAccount.yearUntil +
          "-" +
          this.infoAccount.monthUntil +
          "-" +
          this.infoAccount.dayUntil,
      };
      this.loading.btn = true;

      this.$swal({
        confirmButtonColor: "#dc3545",
        icon: "info",
        title: "Info",
        text: "La descarga se esta iniciando, por favor espere un momento",
      });

      axios
        .post("api/download", data, {
          responseType: "arraybuffer",
        })
        .then((res) => {
          this.loading.btn = false;
          const file = new Blob([res.data], {
            type: "application/pdf;charset=utf-8;",
          });
          const fileURL = URL.createObjectURL(file);
          const link = document.createElement("a");
          link.href = fileURL;
          link.download =
            "reporte-generado-" +
            new Date().toISOString().substr(0, 10) +
            ".pdf";
          link.click();
          this.disableLoading = false;
        })
        .catch((error) => {
          console.log(error.response.status);
          this.loading.btn = false;
          var sms =
            "Hubo un error al descargar el archivo, contacte con el administrador ";
          if (error.response.status == 400) {
            var sms = "Las fechas enviadas son inválidas ";
          }
          this.$swal({
            confirmButtonColor: "#dc3545",
            icon: "error",
            title: "Oops...",
            text: sms,
          });
        });
    },
    cancelar(e) {
      if (e) {
        $("#dataSendGif").modal("hide");
      }
    },
    openModal() {
      // OBTENER REGALO
      axios
        .get("api/events/get")
        .then((res) => {
          if (res.data.cod == 0) {
            switch (res.data.data.motiveCod) {
              case 0:
                this.resuls = 3;
                this.show.gifting = false;
                break;
              case 1:
                this.resuls = 1;
                this.show.gifting = false;
                break;
              case 2:
                this.$swal({
                  confirmButtonColor: "#dc3545",
                  icon: "info",
                  title: "alerta",
                  text: res.data.message,
                });
                this.show.gifting = true;
                break;
              case 3:
                this.resuls = 2;
                this.show.gifting = false;
                break;
              case 4:
                $("#dataSendGif").modal("show");
                this.eventId = res.data.data.info.event_id;
                this.show.gifting = true;
                break;
              default:
                this.$swal({
                  confirmButtonColor: "#dc3545",
                  icon: "error",
                  title: "alerta",
                  text: res.data.message,
                });
                this.show.gifting = true;
                break;
            }

            setTimeout(() => {
              this.resuls = 4;
            }, 5000);
          }
        })
        .catch(() => {
          this.$swal({
            confirmButtonColor: "#dc3545",
            icon: "error",
            title: "Oops...",
            text: sms,
          });
        });
    },
    getGenders() {
      axios
        .get("api/getGenders")
        .then((res) => {
          if (res.data.cod == 0) {
            this.listGenders = res.data.data;
          }
        })
        .catch((error) => {
          this.$swal({
            confirmButtonColor: "#dc3545",
            icon: "error",
            title: "Oops...",
            text: error.response.data.message,
          });
        });
    },
    downloadVoucher() {
      var a = document.createElement("a");
      a.download = true;
      a.target = "_blank";
      a.href = this.purchaseData.products.img;
      a.click();
    },
    openModalDetails(data) {
      data.showBtn = false;
      this.purchaseData = {};
      if (data.product_type_id == 4) {
        $("#loadingModal").modal("show");
        axios
          .get("superAdmin/commerce/won/get/bonusDetail/" + data.bonus_id)
          .then((res) => {
            $("#loadingModal").modal("hide");
            $("#exampleModalDetailsM").modal("show");
            this.purchaseData = data;
            if (res.data.data) {
              this.purchaseData.day_of_activation =
                res.data.data.data.day_of_activation;
              this.purchaseData.expiration_date =
                res.data.data.data.expiration_date;
              this.purchaseData.code = res.data.data.data.code;
            }
          })
          .catch((error) => {
            $("#loadingModal").modal("hide");
            this.$swal({
              confirmButtonColor: "#dc3545",
              icon: "error",
              title: "Oops...",
              text: error.response.data.message,
            });
          });
      } else if (data.product_type_id == 6) {
        $("#exampleModalDetailsM").modal("show");
        this.loading.descriptionAll = true;
        if (data.bonus_id != null) {
          console.log(1);
          if (data.bonus_id.length >= 4) {
            console.log("entro");
            var validate =
              data.bonus_id[0] +
              data.bonus_id[1] +
              data.bonus_id[2] +
              data.bonus_id[3]; // se mantiene quemado porque siempre van a estar estas posiciones
            console.log(validate);
            if (validate == "http") {
              data.showBtn = true;
            }
          }
        }
        if (data.zwappId != null) {
          axios
            .get("api/product/zwapp/" + data.zwappId)
            .then((res) => {
              this.loading.descriptionAll = false;
              if (res.data.cod == 0) {
                this.purchaseData = data;
                this.purchaseData.descrip = res.data.data.description;
              }
            })
            .catch(() => {
              this.purchaseData = data;
              this.loading.descriptionAll = false;
            });
        }
      } else {
        $("#exampleModalDetailsM").modal("show");
        this.purchaseData = data;
      }
    },
    validateSendBtn() {
      if (this.emailReferred !== "" && this.code1 !== "") {
        this.redeemEmail();
      }
      if (this.emailReferred !== "" && this.code1 === "") {
        this.redeemEmail();
      }
      if (this.code1 !== "" && this.emailReferred === "") {
        this.redeemCode();
      }
      if(!this.code1){
        this.errors.code1 = "El código es obligatorio."
        return false;
      }
    },
    redeemEmail() {
      var data = {
        email: this.emailReferred,
      };
      if (this.errors.emailReferred1 == false) {
        axios
          .post("superAdmin/user/shared/validate", data)
          .then((res) => {
            if (res.data.cod == 0) {
              this.$swal({
                confirmButtonColor: "#dc3545",
                icon: "success",
                title: "Muy bien",
                text: res.data.message,
              });
              this.emailReferred = "";
              this.hidden.referred = true;
              if (this.code1 != null) {
                this.redeemCode();
              }
            }
          })
          .catch((error) => {
            this.$swal({
              confirmButtonColor: "#dc3545",
              icon: "error",
              title: "Oops...",
              text: error.response.data.message,
            });
          });
      }
    },
    share() {
      this.listShareEmail = [];
      if (!this.errors.shareEmail) {
        this.listShareEmail.push(this.shareEmail);
        if (this.listShareEmail.length > 0) {
          this.errors.email = false;
          var data = {
            emails: this.listShareEmail,
          };
          this.disableLoading = true;
          axios
            .post("superAdmin/user/shared/email", data)
            .then((res) => {
              if (res.data.cod == 0) {
                this.$swal({
                  confirmButtonColor: "#dc3545",
                  icon: "success",
                  title: "Muy bien",
                  text: res.data.message,
                });
                this.listShareEmail = [];
                this.shareEmail = "";
                $("#compartirModal").modal("hide");
              } else {
                this.$swal({
                  confirmButtonColor: "#dc3545",
                  icon: "error",
                  title: "Oops...",
                  text: res.data.message,
                });
              }
              this.disableLoading = false;
            })
            .catch((error) => {
              this.disableLoading = false;
              this.$swal({
                confirmButtonColor: "#dc3545",
                icon: "error",
                title: "Oops...",
                text: error.response.data.message,
              });
            });
        } else {
          this.errors.shareEmail = "El correo electrónico es requerido.";
        }
      }
    },
    validEmail(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    addEmailShare() {
      if (this.validEmail(this.shareEmail)) {
        this.errors.email = false;
        var validateEmail = this.listShareEmail.indexOf(this.shareEmail);
        if (validateEmail == -1) {
          this.listShareEmail.push(this.shareEmail);
          this.shareEmail = "";
        } else {
          this.errors.email =
            "El correo electrónico ya se encuentra registrado.";
        }
      } else {
        this.errors.email = "El correo electrónico debe ser válido.";
      }
    },
    removeEmail(i) {
      this.listShareEmail.splice(i, 1);
    },
    validateUpdate() {
      return this.dataUser.gender_id != 4
        ? this.updateData()
        : (this.errors.genderId = "El campo género es obligatorio");
    },
    updateData() {
      this.errors.genderId = "";
      var data = {
        documentType: this.dataUser.document_type_id,
        documentNumber: this.dataUser.document_number,
        name: this.dataUser.name,
        lastName: this.dataUser.last_name,
        stateId: this.dataUser.state_id,
        cityId: this.dataUser.city_id,
        plate: this.dataUser.plate,
        address: this.dataUser.address,
        phone: this.dataUser.phone,
        genderId: this.dataUser.gender_id,
        email: this.dataUser.email,
        birthdate: this.dataUser.birthdate,
        motorcycleBrand: this.dataUser.motorcycle_brands_id,
        motorcycleBrandOther: this.dataUser.motorcycle_brand_other,
        motorcycleCylinder: this.dataUser.motorcycle_cylinder_sizes_id,
        motorcycleUse: this.dataUser.motorcycle_uses_id,
        motorcycleUseOther: this.dataUser.motorcycle_use_other,
      };
      this.disableLoadingSend = true;
      axios
        .put("api/update", data)
        .then((res) => {
          if (res.data.cod == 0) {
            $("#exampleModalUpdate").modal("hide");
            this.$swal({
              confirmButtonColor: "#dc3545",
              icon: "success",
              title: "Muy bien",
              text: res.data.message,
            });
            this.disableLoadingSend = false;
            this.getDataUser();
          }
        })
        .catch((error) => {
          this.$swal({
            confirmButtonColor: "#dc3545",
            icon: "error",
            title: "Oops...",
            text: error.response.data.message,
          });
          this.disableLoadingSend = false;
        });
    },
    getListStates() {
      var app = this;
      axios
        .get("api/getStates")
        .then(function(res) {
          app.listDocuments = res.data.states;
        })
        .catch(function(err) {
          console.log(err);
        });
    },
    getCities(stateId) {
      var app = this;
      var data = {
        stateId: stateId,
      };
      axios
        .post("api/showCity", data)
        .then(function(res) {
          app.listCities = res.data.cities;
        })
        .catch(function(err) {
          console.log(err);
        });
    },
    getTypeDocuments() {
      var app = this;
      axios
        .get("api/documentTypeController")
        .then(function(res) {
          app.listTypeDocuments = res.data.TypeDocument;
        })
        .catch(function(err) {
          console.log(err);
        });
    },
    openHistory() {
      if (this.history) {
        this.history = true;
      } else {
        this.history = true;
        this.shopping = false;
        this.showLicense = false;
      }
      this.getHistory();
    },
    openShopping() {
      if (this.shopping) {
        this.shopping = false;
      } else {
        this.shopping = true;
        this.history = false;
        this.showLicense = false;
        this.ranking = false;
        this.game = false;
      }
      this.getShipping();
    },
    getShipping() {
      this.listShopping = [];
      axios
        .get("superAdmin/commerce/shoppingHistory")
        .then((res) => {
          if (res.data.cod == 0) {
            var list = res.data.data;
            if (list.length == 0) {
              this.alert.status = true;
              this.alert.message = "No se encontraron compras.";
            } else {
              for (let i = 0; i < list.length; i++) {
                for (let j = 0; j < list[i].order_products.length; j++) {
                  var data = {
                    bonus_id: list[i].order_products[j].bonus_id,
                    description: list[i].order_products[j].product.description,
                    img: list[i].order_products[j].product.img,
                    name: list[i].order_products[j].product.name,
                    points: list[i].order_products[j].product.points,
                    product_type_id:
                      list[i].order_products[j].product.product_type_id,
                    product_id: list[i].order_products[j].product_id,
                    statusDes: list[i].order_products[j].status.name,
                    created_at: list[i].order_products[j].created_at,
                    price: list[i].order_products[j].product.price,
                    zwappId: list[i].order_products[j].id_won,
                  };
                  this.listShopping.push(data);
                }
              }
              this.alert.status = false;
              this.alert.message = "";
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    openAccount() {
      $("#account-state").modal("show");
    },
    openLicense(){
      if(this.showLicense){
        this.showLicense = false;
      } else {
        this.showLicense = true;
        this.shopping = false;
        this.ranking = false;
        this.game = false;
      }
    },
    openRanking(){
      if(this.ranking){
        this.ranking = false;
      } else {
        this.ranking = true;
        this.shopping = false;
        this.showLicense = false;
        this.game = false;
      }
      this.getRanking();
    },
    getRanking(){
      axios
      .get('api/get-biker-ranking')
      .then((res) => {
        if(res.data.cod == 0){
          this.listRanking = [];
          const ranking = res.data.data.ranking;
          const distributor = res.data.data.distributor;

          if(distributor.id == 1){ // Motero de la zona de OILRED
            if([5, 20, 21].includes(this.dataUser.state_id)){ // Zona Norte
              ranking.forEach(element => {
                if ([5, 20, 21].includes(element.state_id)) {
                  this.listRanking.push(element);
                }
              });
            }
            else if([2, 14].includes(this.dataUser.state_id)){ // Zona Sur
              ranking.forEach(element => {
                if ([2, 14].includes(element.state_id)) {
                  this.listRanking.push(element);
                }
              });
            }
          }
          // else if(distributor.id == 5){ // Motero de la zona de DLO

          // } 
          else {
            this.listRanking = ranking;
          }

          const fullName = res.data.data.distributor.name;
          const nameParts = fullName.split('. ');
          this.distRanking = nameParts[1];
        } else {
          this.$swal({
            icon: "error",
            title: "Oops...",
            text: res.data.message,
            confirmButtonColor: "#dc3545",
          });
        }
      })
      .catch(() => {
        this.$swal({
          icon: "error",
          title: "Oops...",
          text: res.data.message,
          confirmButtonColor: "#dc3545",
        });
      });
    },
    hideName(name){
      if (name.length <= 2) {
        return name;
      }
      const firstLetter = name.charAt(0);
      const lastLetter = name.charAt(name.length - 1);
      const stars = '*'.repeat(name.length - 2);
      return `${firstLetter}${stars}${lastLetter}`;
    },
    showGame(){
      if(this.game){
        this.game = false;
      } else {
        this.game = true;
        this.history = false;
        this.shopping = false;
        this.showLicense = false;
        this.ranking = false;
      }
    },
    saveScore(score, time){
      axios
      .post('api/save-score', {
        idUser: this.dataUser.id,
        points: score,
        time: time
      })
      .then((res) => {
        // console.log(res.data.message);
        this.getDataUser();
      })
      .catch((error) => {
        console.error('Error al guardar la puntuación:', error);
      });
    },
    downloadPDF() {
      this.loading.btn = true;
      const element = document.getElementById('user_data_carnet');

      const options = {
        scale: 4,
        scrollY: 0,
        windowWidth: document.documentElement.offsetWidth,
        windowHeight: document.documentElement.offsetHeight
      };

      html2canvas(element, options).then((canvas) => {
        const imgData = canvas.toDataURL('image/png');
        const pdfWidth = canvas.width * 0.75; // Usamos el ancho del lienzo del canvas para establecer el ancho del PDF
        const pdfHeight = canvas.height * 0.75; // Usamos el alto del lienzo del canvas para establecer el alto del PDF

        const pdf = new jsPDF('p', 'pt', [pdfWidth, pdfHeight]); // Creamos el objeto jsPDF con las dimensiones adecuadas

        pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight, '', 'FAST');
        pdf.save(`Carnet_Motero_${this.dataUser.name}.pdf`);
        this.loading.btn = false;
      });
    },
    getHistory() {
      this.loading.list = true;
      axios
        .get("superAdmin/commerce/historicCodes")
        .then((res) => {
          if (res.data.cod == 0) {
            this.loading.list = false;
            var cont = 1;
            if (res.data.data.codes.length == 0) {
              this.alert.status = true;
              this.alert.message = "No se encontraron códigos redimidos.";
              return false;
            } else {
              this.alert.status = false;
              this.alert.message = "";
              this.listHistory = res.data.data.codes.map((element) => {
                return {
                  date: element.updated_at,
                  num: cont++,
                  point: 1,
                };
              });
            }
          }
        })
        .catch((error) => {
          this.loading.list = false;
          this.$swal({
            confirmButtonColor: "#dc3545",
            icon: "error",
            title: "Oops...",
            text: error.response.data.message,
          });
        });
    },
    changePassword() {
      var app = this;
      if (this.validateForm()) {
        this.disableLoadingSend = true;
        this.form.email = this.dataUser.email;
        this.form.check = 1;
        axios
          .post("api/changePassword", this.form)
          .then(function(res) {
            if (res.data.ResponseCode == 0) {
              $("#exampleModalPassword").modal("hide");
              app.$swal({
                confirmButtonColor: "#dc3545",
                icon: "success",
                title: "Muy bien",
                text: res.data.ResponseMessage,
              });
              app.disableLoadingSend = false;
            } else if (res.data.ResponseCode == 1) {
              app.$swal({
                confirmButtonColor: "#dc3545",
                icon: "error",
                title: "Oops...",
                text: res.data.ResponseMessage,
              });
              app.disableLoadingSend = false;
            } else {
              app.$swal({
                confirmButtonColor: "#dc3545",
                icon: "error",
                title: "Oops...",
                text: res.data.ResponseMessage,
              });
              app.disableLoadingSend = false;
            }
          })
          .catch(function(err) {
            console.log(err);
            app.$swal({
              confirmButtonColor: "#dc3545",
              icon: "error",
              title: "Oops...",
              text: "Hubo un error en el sistema, intente nuevamente",
            });
            app.disableLoadingSend = false;
          });
      }
    },
    getValidareGiftng() {
      axios
        .get("api/events/verified")
        .then((res) => {
          if (res.data.cod == 0) {
            this.show.gifting = res.data.data;
          }
        })
        .catch(() => {
          this.show.gifting = false;
        });
    },
    getAddEventGifting() {
      console.log("------- ADD GIFTING ---------");
      axios
        .get("api/events/user/register")
        .then((res) => {
          if (res.data.cod == 0) {
            this.show.gifting = res.data.data;
          }
        })
        .catch(() => {
          this.show.gifting = false;
        });
    },
    redeemCode() {
      this.disableLoading = true;
      var app = this;
      var data = {
        code: this.code1,
        codePromotional: this.codePromotional,
      };
      axios
        .post("superAdmin/redeemCode", data)
        .then(function(res) {
          app.disableLoading = false;
          if (res.data.ResponseCode == 0) {
            app.$swal({
              confirmButtonColor: "#dc3545",
              icon: "success",
              title: "Muy bien",
              text: res.data.ResponseMessage,
            });
            app.getAddEventGifting();
            app.sendEvent();
          } else if (res.data.ResponseCode == 1) {
            app.$swal({
              icon: "warning",
              title: "Oops...",
              confirmButtonColor: "#dc3545",
              text: res.data.ResponseMessage,
            });
          } else {
            app.$swal({
              confirmButtonColor: "#dc3545",
              icon: "error",
              title: "Oops...",
              text: res.data.ResponseMessage,
            });
          }
          app.getDataUser();
          app.code1 = "";
        })
        .catch(function(error) {
          app.$swal({
            confirmButtonColor: "#dc3545",
            icon: "error",
            title: "Oops...",
            text: error.response.data.message,
          });
          app.disableLoading = false;
        });
    },
    downloadBonus(data) {
      var link = document.createElement("a");
      link.setAttribute("href", data.bonus_id);
      link.setAttribute("target", "_blank");
      link.setAttribute("download", "Bono.pdf");
      document.body.appendChild(link);
      link.click();
    },
    getDataUser() {
      var app = this;
      app.loading.profile = true;
      axios
        .get("api/showUser")
        .then(function(res) {
          app.loading.profile = false;
          app.dataUser = res.data.User;
          app.documentUser =
            res.data.User.document_type != null
              ? res.data.User.document_type.name
              : null;
          app.cityUser =
            res.data.User.city != null ? res.data.User.city.name : null;
          app.redeemCodes = res.data.Codes;
          app.eventPoints = res.data.User.event_points;
          app.points = res.data.Points;
          app.points = Number.parseFloat(app.points).toFixed(1);
          if (res.data.User.referred == 0) {
            app.hidden.referred = true;
          } else {
            app.hidden.referred = false;
          }
          app.getExpiredPoints(app.dataUser.id);
          if(
              app.dataUser.name == "" || app.dataUser.name == null || 
              app.dataUser.last_name == "" || app.dataUser.last_name == null || 
              app.dataUser.address == "" || app.dataUser.address == null || 
              app.dataUser.phone == "" || app.dataUser.phone == null || 
              app.dataUser.email == "" || app.dataUser.email == null || 
              app.dataUser.birthdate == "" || app.dataUser.birthdate == null
            ){
              $('#exampleModalUpdate').modal({backdrop: 'static', keyboard: false});
              $('.close_update, .btn_cancel').css("display", "none");
          }
        })
        .catch(function(error) {
          app.loading.profile = false;
          console.log(error);
        });
    },
    getExpiredPoints(idUser){
      axios
      .post("superAdmin/expired/points/" + idUser)
      .then((response) => {
        if(response.data.cod == 0){
          this.expired_points = response.data.data.pointsMot;
        } else {
          this.$swal({
            icon: "error",
            title: "Oops...",
            text: response.data.message,
            confirmButtonColor: "#dc3545",
          });
        }
      })
      .catch((error) => {
        this.$swal({
          icon: "error",
          title: "Oops...",
          text: error.response.data.message,
          confirmButtonColor: "#dc3545",
        });
      });
    },
    confirmation(e) {
      $("#dataSendGif").modal("hide");
      e.eventId = this.eventId;
      axios
        .post("api/data/send/register", e)
        .then((res) => {
          if (res.data.cod == 0) {
            this.openModal();
          }
        })
        .catch((error) => {
          this.$swal({
            confirmButtonColor: "#dc3545",
            icon: "error",
            title: "Oops...",
            text: error.response.data.message,
          });
        });
    },
    validateForm() {
      if (!this.form.pass) {
        this.errors.pass = "La contraseña nueva es requerida.";
      }
      if (!this.form.currentPassword) {
        this.errors.currentPassword = "La contraseña actual es requerida.";
      }
      if (!this.form.pass_confirmation) {
        this.errors.pass_confirmation = "La confirmación de la contraseña es requerida.";
      }
      if (this.form.pass_confirmation != this.form.pass) {
        this.errors.pass_confirmation = "Las contraseñas deben ser iguales";
      }

      if (
        !this.errors.pass &&
        !this.errors.pass_confirmation &&
        !this.errors.currentPassword &&
        !this.validPassword(this.errors.pass)
      ) {
        return true;
      }
      return false;
    },
    validPassword(pass) {
      var re = /^(?=\w*\d)(?=\w*[A-Z])(?=\w*[a-z])\S{8,16}$/;
      return re.test(pass);
    },
    validateSharePassword() {
      if (!this.shareEmail) {
        this.errors.pass = "La contraseña nueva es requerida.";
      }
      if (!this.validEmail(this.shareEmail)) {
        this.errors.currentPassword = "La contraseña actual es requerida.";
      }
    },
    deshabilitaRetroceso(){
      window.location.hash="no-back-button";
      window.location.hash="Again-No-back-button" //chrome
      window.onhashchange=function(){window.location.hash="";}
    },
    getBrands(){
      axios
      .get("api/motorcycleBrands/get")
      .then((res) => {
        if (res.data.cod == 0) {
          this.listBrands = res.data.data;
        }
      })
      .catch((error) => {
        this.$swal({
          confirmButtonColor: "#dc3545",
          icon: "error",
          title: "Oops...",
          text: error.response.data.message,
        });
      });
    },
    getMotorcycleCylinder(){
      axios
      .get("api/motorcycleCylinder/get")
      .then((res) => {
        if (res.data.cod == 0) {
          this.listCylinders = res.data.data;
        }
      })
      .catch((error) => {
        this.$swal({
          confirmButtonColor: "#dc3545",
          icon: "error",
          title: "Oops...",
          text: error.response.data.message,
        });
      });
    },
    getMotorcycleUses(){
      axios
      .get("api/motorcycleUses/get")
      .then((res) => {
        if (res.data.cod == 0) {
          this.listUses = res.data.data;
        }
      })
      .catch((error) => {
        this.$swal({
          confirmButtonColor: "#dc3545",
          icon: "error",
          title: "Oops...",
          text: error.response.data.message,
        });
      });
    },
    showPass(type){
      if(type == 1){
        let pass = this.$refs.current_password;
        if(pass.type == "password"){
          pass.type = "text";
          $('#pass1').addClass('fa-eye');
          $('#pass1').removeClass('fa-eye-slash');
        } else {
          pass.type = "password";
          $('#pass1').addClass('fa-eye-slash');
          $('#pass1').removeClass('fa-eye');
        }
      } 
      else if(type == 2){
        let pass = this.$refs.password;
        if(pass.type == "password"){
          pass.type = "text";
          $('#pass2').addClass('fa-eye');
          $('#pass2').removeClass('fa-eye-slash');
        } else {
          pass.type = "password";
          $('#pass2').addClass('fa-eye-slash');
          $('#pass2').removeClass('fa-eye');
        }
      } else {
        let pass = this.$refs.confirm_password;
        if(pass.type == "password"){
          pass.type = "text";
          $('#pass3').addClass('fa-eye');
          $('#pass3').removeClass('fa-eye-slash');
        } else {
          pass.type = "password";
          $('#pass3').addClass('fa-eye-slash');
          $('#pass3').removeClass('fa-eye');
        }
      }
    },
    handleVisibilityChange() {
      if (document.visibilityState === 'hidden') {
        this.game = false;
      }
    },
    handleBlur() {
      this.game = false;
    },
    // getIp(){
    //   axios
    //   .get("https://ipinfo.io/json")
    //   .then((res) => {
    //     if(res.status == 200){
    //       this.ip_address = res.data.ip;
    //     }
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   });
    // },
    sendEvent(){
      axios
      .post("api/send-data-event", {
        event_name: "Inscripción de códigos Moteros",
        event_time: Math.floor(Date.now() / 1000),
        event_source_url: document.URL,
        action_source: "website",
        user_data: {
          client_ip_address: this.ip_address,
          client_user_agent: window.navigator.userAgent
        }
      })
      .then(() => {
        console.log("Evento enviado correctamente.");
      })
      .catch((err) => {
        console.log("Error enviando el evento:", err);
      });
    },
  },
  watch: {
    emailReferred(n) {
      if (!n) {
        this.errors.emailReferred1 = false;
      } else if (!this.validEmail(n)) {
        this.errors.emailReferred1 = "El correo electrónico es incorrecto.";
      } else {
        this.errors.emailReferred1 = false;
      }
    },
    shareEmail(n) {
      if (!n) {
        this.errors.shareEmail = false;
      } else if (!this.validEmail(n)) {
        this.errors.shareEmail = "El correo electrónico es incorrecto.";
      } else {
        this.errors.shareEmail = false;
      }
    },
    "dataUser.state_id": function(n) {
      if (n) {
        this.getCities(n);
      }
    },
    "form.currentPassword": function(n) {
      if (!n) {
        this.errros.currentPassword = "La contraseña es requerida.";
      } else {
        this.errors.pass = false;
      }
    },
    "form.pass": function(n) {
      if (!n) {
        this.errors.pass = "La contraseña es requerida.";
      } else if (!this.validPassword(n)) {
        this.errors.pass =
          "La contraseña es inválida, debe tener entre 8 a 16 carácteres, al menos un dígito, al menos una minúscula y al menos una mayúscula. Puede tener otros símbolos.";
      } else {
        this.errors.pass = false;
      }
      if (this.form.pass_confirmation == this.form.pass) {
        this.errors.pass_confirmation = false;
      } else {
        this.errors.pass_confirmation = "Las contraseñas deben ser iguales";
      }
    },
    "form.pass_confirmation": function(n) {
      if (this.form.pass_confirmation == this.form.pass) {
        this.errors.pass_confirmation = false;
      } else {
        this.errors.pass_confirmation = "Las contraseñas deben ser iguales";
      }
    },
  },
  created() {
    this.infoUser = JSON.parse(sessionStorage.getItem("infoUser"));
  },
  mounted() {
    // var iPCode = document.getElementById("i-p-code");
    // iPCode.type = "text";
    // iPCode.removeAttribute("autocomplete");
    // var some_id = $("#i-p-code");
    // some_id.prop("type", "text");
    // some_id.removeAttr("autocomplete");
    this.getDataUser();
    this.getValidareGiftng();
    this.getGenders();
    this.getTypeDocuments();
    this.getListStates();
    this.deshabilitaRetroceso();
    this.getBrands();
    this.getMotorcycleCylinder();
    this.getMotorcycleUses();
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
    window.addEventListener('blur', this.handleBlur)
    if (window.innerWidth >= 768) {
      this.device = true;
    }
    // this.getIp();
  },
  beforeDestroy() {
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    window.removeEventListener('blur', this.handleBlur);
  }
};
</script>

<style scoped>
body {
  padding-right: 0px !important;
}
.th-account-1 {
  background-color: #d82112;
  color: #fff;
}
.th-account {
  background-color: #f32918;
  color: #fff;
}
.table-account-t td:nth-child(1) {
  background-color: #e7e7e7;
}
.table-account-t td:nth-child(3) {
  background-color: #e7e7e7;
}
.table-account-t td:nth-child(5) {
  background-color: #e7e7e7;
}
.table-account {
  padding: 6px;
  background-color: #fff;
  height: 300px;
  overflow: auto;
}
.btn-get-black {
  background-color: #000;
  color: #fff;
  margin-top: 110px;
}
.btn-down-yellow {
  border-radius: 30px;
  background-color: #fdd200;
  color: #d82233;
  font-weight: bold;
  padding: 4px 50px 4px 50px;
}
.btn-down-yellow:hover {
  color: "#ffffff" !important;
}
.div-account {
  margin: 0px;
  padding: 3px 0px 3px 0px;
  background-color: #fff;
  width: 100%;
}
.img-account {
  border-radius: 22px;
  background-position: center;
  background-image: url("./../../assets/img/infoLubricador.jpg");
}
.loading-modal {
  margin-top: 25%;
}
.card-history-s {
  height: 225px;
}
.compartirModal {
  background-size: cover;
  background-image: url("../../assets/img/foto_8.jpg");
  background-position: center center;
  background-attachment: fixed;
  background-color: "#171717";
}
.icon-email {
  color: red;
  font-size: x-large;
}
.circle-email {
  position: relative;
  right: 25px;
  background-color: #fff;
  height: 40px;
  width: 40px;
  padding: 7px 8px;
  z-index: 3;
}
.button-shared {
  padding-left: 30px;
  padding-right: 40px;
  border-radius: 30px;
}
.v-step-warp-vertical .v-step-item {
  padding-top: 30px;
}
li.v-step-item:first-child {
  padding-top: 0px !important;
}
.modal-title {
  color: #595959 !important;
}
.prod-card {
  width: 100px;
}
.table-h {
  border-radius: 25px;
}
.table-light tbody + tbody,
.table-light td,
.table-light th,
.table-light thead th {
  border-color: #d8d8dc;
}
.subtitle-h {
  text-align: left;
  color: #dc3545;
  font-size: 28px;
  font-family: "GothamBoldItalic", sans-serif;
}
.color-input-shared {
  font-size: 15px;
  background-color: #ffffff00 !important;
  height: 35px !important;
  color: #fff !important;
  position: relative;
  padding: 0.375rem 3rem !important;
}
.color-input-shared::placeholder {
  color: white !important;
}
.info-promo {
  text-align: left;
  font-size: small;
  padding-bottom: 0px;
  margin-bottom: 5px;
}
.info-shared {
  text-align: initial;
  font-weight: bold;
  color: #fdd200;
}

/* History codes */
#content-history-id {
  padding-top: 2%;
  padding-bottom: 2%;
}
.content-history {
  background-color: #eaeaea;
}
.btn-history {
  cursor: pointer;
}
.btn-history-s:hover {
  cursor: pointer;
  background-color: #0060c3;
}
.btn-history:hover {
  cursor: pointer;
  background-color: #d82233;
}
.th-title {
  color: #dc3545;
}
.color-option {
  color: black !important;
}

/* End history code */
.padding-title {
  padding-bottom: 12% !important;
}
.p-phone {
  padding-left: 8%;
}
.p-historial {
  cursor: pointer;
  color: #ffffff;
}
.p-historial:hover {
  color: #dc3545;
}
.text-profile {
  font-size: 13px;
}
.icon-img-svg-phone {
  width: 28px;
  height: 40px;
  margin-top: 13%;
  /* float: right; */
}
.icon-img-svg {
  width: 45px;
  height: 30px;
  margin-top: 13%;
  float: right;
}
.icon-img-svg-name {
  width: 60px;
  height: 60px;
}
.label-title {
  font-size: 20px;
  margin-bottom: 0rem !important;
}
.title-profile-a {
  text-align: left !important;
  color: #efc700;
}
.title-profile-1 {
  font-family: "Gotham-UltraItalic", sans-serif;
  text-align: left !important;
  font-size: 50px;
  font-display: swap;
}
.title-profile-admin {
  font-family: "Gotham-UltraItalic", sans-serif;
  text-align: center !important;
  font-size: 50px;
  font-display: swap;
  margin-top: 20px;
}
.button-send-code {
  border-radius: 5px !important;
  padding: 9px !important;
}
.text-points {
  padding-top: 4%;
  font-size: 65px;
  font-family: "GothamBoldItalic", sans-serif;
  margin-bottom: 0px;
}
.points {
  padding: 2%;
  margin-bottom: 7%;
  border: 1px solid;
  border-color: white;
  border-radius: 5px;
}
.title-profile {
  text-align: left !important;
  color: white !important;
}
.title-profile-user {
  font-size: 13px !important;
}
.content-profile-user {
  padding-right: 5%;
  padding-left: 5%;
  padding-top: 4%;
  padding-bottom: 5%;
  height: 100%;
}
.input-reset {
  background-color: #ffffff00 !important;
  border-radius: 10px !important;
  border-color: white !important;
  height: 30px !important;
  color: white !important;
  position: relative;
  padding: 0.375rem 3rem !important;
}
.input-reset ::placeholder {
  color: white !important;
}
.icon::before {
  position: absolute;
  top: 20%;
  left: 5%;
}
.fa.iconreset {
  color: white;
}
#contentProfileUser {
  background-size: cover;
  background-image: url("../../assets/img/moto-01.jpg");
  background-position: center center;
  background-attachment: fixed;
  background-color: "#171717";
}
.input-code {
  background-color: #ffffff00 !important;
  border-radius: 5px !important;
  border-color: white !important;
  height: 40px !important;
  color: white !important;
  padding: 0.375rem 1.7rem !important;
  font-size: 13px !important;
}
.input-code::placeholder {
  color: white;
}
.container-fluid,
.container-lg,
.container-md,
.container-sm,
.container-xl {
  padding-right: 0px !important;
  padding-left: 0px !important;
  overflow: hidden;
}
#content_title_carnet{
  margin: auto;
  display: flex;
}
.title_carnet {
  color: #dc3545;
  font-size: 28px;
  font-family: "GothamBoldItalic", sans-serif;
  margin: 30px;
}
#content_carnet{
  margin: auto;
}
#user_data_carnet{
  margin: auto;
  width: 530px;
  height: 768px;
  background-image: url('../../assets/imgsCarnet/background_carnet.jpg');
  background-position: center;
  background-size: cover;
}
.data_carnet{
  padding: 60% 0% 0% 0%;
}
.name_and_last_name{
  background-color:#838384; 
  border-radius:20px; 
  float:left; 
  padding:2px 50px 2px 50px; 
  margin:auto auto auto 15px;
}
.cc_and_document{
  width:100%; 
  text-align:left; 
  float:left; 
  padding:2px 20px 2px 50px; 
  margin:auto auto 15px 15px;
}
.user_role, .user_plate, .user_city{
  width:100%; 
  text-align:left; 
  float:left; 
  padding:2px 20px 2px 50px; 
  margin:auto auto auto 15px;
}
.user_activo{
  max-width: 80%;
  margin: auto;
  padding: 20px 0px 0px 0px;
}
.miembro_activo{
  font-size: 30px;
  text-align: center;
}
.havoline_motoclub{
  font-size: 18px;
  color: #ff1212;
}
.red_line{
  max-width: 55%;
  margin: auto;
  border-bottom: 3px solid #ff1212;
}
.qr_code{
  display: flex; 
  justify-content: center;
}
.info_adicional{
  max-width: 75%;
  margin: 10px auto auto auto;
  line-height: 13px;
}
#btn_download_carnet{
  width: 40%;
  margin: 25px auto 25px auto;
}
#img_product{
  width: 140px;
  height: 140px;
}
.modal-header .close {
  font-size: 40px;
  color: #dc3545;
}
#close_detail_product{
  padding: 10px;
  margin: -40px 0px 0px -25px;
  font-size: 40px;
  color: #dc3545;
}
.expired_points{
  padding: 2%;
  margin-bottom: 7%;
  border: 1px solid;
  border-color: white;
  border-radius: 5px;
}
.title_expired_points{
  font-size: 16px;
  font-family: "GothamBoldItalic", sans-serif;
}
.cant_expired_points{
  font-size: 25px;
  font-family: "GothamBoldItalic", sans-serif;
  margin: auto;
}
.eye_pass{
  position: absolute;
  height: 100%;
  right: 5%;
  padding-top: 4px;
  cursor: pointer;
  z-index: 1000;
  color: #dc3545;
}
.name-container {
  position: relative;
  display: inline-block;
}
.bubble {
  position: absolute;
  bottom: 0%;
  right: 100%;
  transform: translateX(-50%);
  background-color: #dc3545;
  color: #fff;
  padding: 5px 20px;
  border-radius: 5px;
  white-space: nowrap;
  z-index: 10;
  font-size: 12px;
  /* Mostrar la burbuja siempre */
  visibility: visible;
  opacity: 1;
}
.ranking_notice{
  padding: 5px 10px;
}
.warning, .text_warning{
  color: black;
  font-size: 16px;
}
.distName{
  color: #1da5df;
}

/* LAPTOP NORMAL */
@media (max-width: 1200px) {
  .loading-modal {
    margin-top: 40% !important;
  }
}

/* TABLET */
@media (max-width: 1023px) {
  .btn-get-black {
    margin-top: 140px;
  }
  .loading-modal {
    margin-top: 40% !important;
  }
  .padding-sm-code {
    padding-bottom: 10%;
    padding-top: 0%;
  }
  .content-profile-user {
    padding-top: 12%;
  }
  .p-phone {
    padding-left: 3%;
  }
}

/* MOBILE */
@media (max-width: 767px) {
  .loading-modal {
    margin-top: 60% !important;
  }
  .p-phone {
    padding-left: 0% !important;
  }
  .mtPass {
    margin-top: 10px;
  }
  .content-profile-user {
    padding-top: 22%;
    padding-bottom: 20%;
  }
  .padding-sm-code {
    padding-top: 0%;
  }
  .icon-img-svg-name {
    width: 38px;
    height: 35px;
    float: left;
  }
  .padding-sm2 {
    padding-left: 0px;
  }
  .btn-get-black {
    margin-top: 0px;
  }
  .title_carnet {
    font-size: 20px;
  }
  #content_carnet{
    margin: auto;
  }
  #user_data_carnet{
    margin: auto;
    width: 98%;
    height: 540px;
    background-image: url('../../assets/imgsCarnet/background_carnet.jpg');
    background-position: center;
    background-size: cover;
  }
  .data_carnet{
    padding: 59% 0% 0% 0%;
  }
  .data_carnet span, b{
    font-size: 10px;
    padding-top: 0px !important;
    padding-bottom: 0px !important;
  }
  .data_carnet b{
    padding: 0px !important;
  }
  .name_and_last_name{
    padding:2px 20px 2px 20px; 
  }
  .cc_and_document{
    padding:2px 20px 2px 20px; 
  }
  .user_role, .user_plate, .user_city{
    padding:0px 20px 0px 20px !important;
  }
  .user_activo{
    max-width: 80%;
    margin: auto;
    padding: 20px 0px 0px 0px;
  }
  .miembro_activo{
    font-size: 22px;
    text-align: center;
  }
  .havoline_motoclub{
    font-size: 12px !important;
    color: #ff1212;
  }
  .red_line{
    max-width: 55%;
    margin: auto;
    border-bottom: 3px solid #ff1212;
  }
  .qr_code div canvas, .qr_code div img{
    max-width: 100px !important;
  }
  .info_adicional{
    max-width: 75%;
    margin: 10px auto auto auto;
    line-height: 13px;
    font-size: 9px !important;
  }
  #btn_download_carnet{
    width: 60%;
    margin: 25px auto 25px auto;
  }
  #img_product{
    width: 140px;
    height: 140px;
  }
  .card-body {
    padding: 0px !important;
  }
  .card-history-s {
    height: 350px !important;
  }
  .card-body > p > b {
    font-size: 12px !important;
  }
  .btn-outline-danger {
    font-size: 11px !important;
  }
  #exampleModalDetailsMLabel > b{
    font-size: 25px !important;
  }
  .bubble {
    right: 70%;
    padding: 2px 10px;
    font-size: 10px;
  }
  .warning, .text_warning{
    color: black;
    font-size: 12px;
  }
  .subtitle-h, .distName {
    font-size: 22px;
  }
  .section_game{
    min-width: 110%;
    right: 5%;
  }
}

@media (max-width: 420px) and (min-width: 390px) {
  .data_carnet{
    padding: 53% 0% 0% 0%;
  }
}

@font-face {
  font-family: "ubuntu-bold";
  src: url("./../../assets/font/Ubuntu-Bold.ttf");
  font-display: swap;
}
@font-face {
  font-family: "Gotham-UltraItalic";
  src: url("./../../assets/font/Gotham-UltraItalic.ttf");
  font-display: swap;
}
@font-face {
  font-family: "GothamBoldItalic";
  src: url("./../../assets/font/GothamBoldItalic.ttf");
  font-display: swap;
}
@font-face {
  font-family: "GothamBookItalic";
  src: url("./../../assets/font/GothamBookItalic.ttf");
  font-display: swap;
}

.hovereffect {
  width: 100%;
  height: 100%;
  float: left;
  overflow: hidden;
  position: relative;
  text-align: center;
  cursor: default;
  background: #000;
}
.hovereffect .overlay {
  width: 100%;
  height: 100%;
  position: absolute;
  overflow: hidden;
  top: 0;
  left: 0;
  padding: 180px 20px;
}
.hovereffect img {
  display: block;
  position: relative;
  max-width: none;
  width: calc(100% + 20px);
  -webkit-transition: opacity 0.35s, -webkit-transform 0.35s;
  transition: opacity 0.35s, transform 0.35s;
  -webkit-transform: translate3d(-10px, 0, 0);
  transform: translate3d(-10px, 0, 0);
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}
.hovereffect:hover img {
  opacity: 0.4;
  filter: alpha(opacity=40);
  -webkit-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
}
.hovereffect a,
.hovereffect p {
  color: #fff;
  opacity: 0;
  filter: alpha(opacity=0);
  -webkit-transition: opacity 0.35s, -webkit-transform 0.35s;
  transition: opacity 0.35s, transform 0.35s;
  -webkit-transform: translate3d(100%, 0, 0);
  transform: translate3d(100%, 0, 0);
}
.hovereffect:hover a,
.hovereffect:hover p {
  opacity: 1;
  filter: alpha(opacity=100);
  -webkit-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
}
.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}
</style>
